var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.38 276.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#656565;}.cls-4{fill:#fff;}.cls-5{fill:#ea5b27;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{clip-path:url(#clip-path-3);}.cls-8{clip-path:url(#clip-path-4);}.cls-9{clip-path:url(#clip-path-5);}.cls-10{clip-path:url(#clip-path-6);}.cls-11{clip-path:url(#clip-path-7);}.cls-12{clip-path:url(#clip-path-8);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.41,156.8l-18.22,10.52c-1.92,1.12-5.29,1-7.51-.31l-17-9.83c-2.22-1.28-2.13-2.89-.21-4l18.22-10.52a7.62,7.62,0,0,1,7.19,0l17,9.83C266.09,153.75,266.34,155.69,264.41,156.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.68,215.15l-12,6.93c-2.11,1.22-5.8,1.06-8.23-.34l-29.79-17.2c-2.43-1.41-2.7-3.53-.59-4.75l12-6.93c2.11-1.21,5.79-1.06,8.22.35l29.79,17.19C197.53,211.81,197.79,213.94,195.68,215.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.52,130.5,47.3,141c-1.92,1.11-5.28,1-7.51-.31l-17-9.83c-2.23-1.29-2.14-2.89-.21-4l18.22-10.51a7.6,7.6,0,0,1,7.18,0l17,9.83C67.21,127.45,67.45,129.39,65.52,130.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.58,243.7l-6.18,3.56a3.82,3.82,0,0,1-3.46-.14l-8.2-4.73c-1-.59-1.13-1.49-.25-2l6.19-3.57a3.83,3.83,0,0,1,3.46.15l8.19,4.73C101.36,242.29,101.47,243.18,100.58,243.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.52,216.55l-6.18,3.57a3.85,3.85,0,0,1-3.46-.14l-8.2-4.73c-1-.6-1.13-1.49-.24-2l6.18-3.57a3.82,3.82,0,0,1,3.46.14l8.19,4.73C55.3,215.14,55.41,216,54.52,216.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141,220l-6.19,3.57a3.86,3.86,0,0,1-3.46-.14l-8.19-4.73c-1-.6-1.14-1.49-.25-2l6.18-3.57a3.82,3.82,0,0,1,3.46.14l8.2,4.73C141.8,218.62,141.91,219.52,141,220Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,252.76l-18.22,10.52a8.36,8.36,0,0,1-7.51-.31l-17-9.83c-2.22-1.29-2.13-2.9-.21-4l18.22-10.52a7.63,7.63,0,0,1,7.18,0l17,9.83C176.63,249.7,176.87,251.65,175,252.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.77,236.89l-18.22,10.52c-1.92,1.11-5.29,1-7.51-.31l-17-9.83c-2.22-1.28-2.13-2.89-.2-4L195,222.75a7.6,7.6,0,0,1,7.18,0l17,9.83C221.46,233.84,221.7,235.78,219.77,236.89Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 221.34,
    y: 152.15,
    width: 55.03,
    height: 0.59,
    transform: "translate(-42.88 144.86) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 222.96,
    y: 153.01,
    width: 55.03,
    height: 0.59,
    transform: "translate(-43.09 145.78) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 224.42,
    y: 153.92,
    width: 55.03,
    height: 0.59,
    transform: "translate(-43.36 146.63) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 226.06,
    y: 154.76,
    width: 55.03,
    height: 0.59,
    transform: "translate(-43.56 147.51) rotate(-29.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 227.42,
    y: 155.71,
    width: 55.03,
    height: 0.59,
    transform: "translate(-43.84 148.19) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 229.03,
    y: 156.57,
    width: 55.03,
    height: 0.59,
    transform: "translate(-44.06 149.13) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 230.5,
    y: 157.48,
    width: 55.03,
    height: 0.59,
    transform: "translate(-44.32 149.95) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 232.14,
    y: 158.33,
    width: 55.03,
    height: 0.59,
    transform: "translate(-44.52 150.92) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.6,
    y: 159.24,
    width: 55.03,
    height: 0.59,
    transform: "translate(-44.78 151.73) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 235.24,
    y: 160.1,
    width: 55.03,
    height: 0.59,
    transform: "translate(-44.99 152.66) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 236.71,
    y: 161.01,
    width: 55.03,
    height: 0.59,
    transform: "translate(-45.25 153.52) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 238.35,
    y: 161.86,
    width: 55.03,
    height: 0.59,
    transform: "translate(-45.45 154.45) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 239.71,
    y: 162.8,
    width: 55.03,
    height: 0.59,
    transform: "translate(-45.74 155.25) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 241.32,
    y: 163.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-45.96 156.17) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 242.78,
    y: 164.58,
    width: 55.03,
    height: 0.59,
    transform: "translate(-46.22 157.05) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 244.43,
    y: 165.42,
    width: 55.03,
    height: 0.59,
    transform: "translate(-46.42 157.96) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 245.89,
    y: 166.33,
    width: 55.03,
    height: 0.59,
    transform: "translate(-46.68 158.86) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.79,
    y: 139.78,
    width: 55.03,
    height: 0.59,
    transform: "translate(-39.59 132.42) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 201.43,
    y: 140.62,
    width: 55.03,
    height: 0.59,
    transform: "translate(-39.79 133.36) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.79,
    y: 141.57,
    width: 55.03,
    height: 0.59,
    transform: "translate(-40.08 134.16) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 204.4,
    y: 142.43,
    width: 55.03,
    height: 0.59,
    transform: "translate(-40.29 135.08) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.87,
    y: 143.34,
    width: 55.03,
    height: 0.59,
    transform: "translate(-40.55 135.98) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.51,
    y: 144.19,
    width: 55.03,
    height: 0.59,
    transform: "translate(-40.75 136.87) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208.97,
    y: 145.1,
    width: 55.03,
    height: 0.59,
    transform: "translate(-41.02 137.73) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.61,
    y: 145.96,
    width: 55.03,
    height: 0.59,
    transform: "translate(-41.23 138.7) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 212.08,
    y: 146.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-41.49 139.51) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 213.72,
    y: 147.72,
    width: 55.03,
    height: 0.59,
    transform: "translate(-41.69 140.49) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 215.08,
    y: 148.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-41.98 141.27) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 216.69,
    y: 149.52,
    width: 55.03,
    height: 0.59,
    transform: "translate(-42.19 142.15) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 218.15,
    y: 150.44,
    width: 55.03,
    height: 0.59,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -42.45, 143.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 219.8,
    y: 151.28,
    width: 55.03,
    height: 0.59,
    transform: "translate(-42.66 144.01) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 221.26,
    y: 152.2,
    width: 55.03,
    height: 0.59,
    transform: "translate(-42.92 144.82) rotate(-30)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.35,149.58h-1.2l-17.31-10a3.93,3.93,0,0,0-3.51-.15L222.9,149.49h0l-1.29.07a.09.09,0,0,0-.09.09v1.12h0a1.37,1.37,0,0,0,.84,1.19l17.75,10.25a3.88,3.88,0,0,0,3.5.15l18.26-10.54a1.07,1.07,0,0,0,.59-.81v-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.06,163.24a4.56,4.56,0,0,1-2.23-.56l-17.75-10.25a2,2,0,0,1-1.09-1.37h0v-1.39a.61.61,0,0,1,.57-.61l1.19-.06,17.35-10a4.36,4.36,0,0,1,4,.15l17.22,9.94h1.49l.15,1.09V151a1.55,1.55,0,0,1-.85,1.25l-18.25,10.54A3.63,3.63,0,0,1,242.06,163.24ZM222,150.52h0v.29c0,.23.21.5.59.72l17.75,10.25a3.37,3.37,0,0,0,3,.14l18.25-10.53a.63.63,0,0,0,.34-.41v-.8l0-.1h-.85l-.16-.08-17.32-10a3.4,3.4,0,0,0-3-.14L223.05,150l-.16,0-.9.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.84,150.52l-18.26,10.54a3.91,3.91,0,0,1-3.5-.15l-17.75-10.25c-1-.6-1.15-1.5-.25-2l18.25-10.54a3.9,3.9,0,0,1,3.51.15l17.75,10.25C262.62,149.09,262.73,150,261.84,150.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.06,161.92a4.56,4.56,0,0,1-2.23-.56l-17.75-10.25a1.94,1.94,0,0,1-1.12-1.59,1.54,1.54,0,0,1,.86-1.32l18.26-10.54a4.38,4.38,0,0,1,4,.14l17.75,10.25a1.94,1.94,0,0,1,1.12,1.59,1.53,1.53,0,0,1-.87,1.32L243.84,161.5A3.63,3.63,0,0,1,242.06,161.92Zm-.21-23.66a2.58,2.58,0,0,0-1.26.29l-18.25,10.54c-.13.07-.35.23-.35.43s.16.44.6.7l17.75,10.25a3.4,3.4,0,0,0,3,.14l18.25-10.54c.13-.07.35-.23.35-.43s-.16-.44-.6-.7l-17.75-10.25A3.61,3.61,0,0,0,241.85,138.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 241.56,
    y: 161.54,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 222.66,
    y: 151.24,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.18,
    y: 152.59,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.51,
    y: 151.13,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.62,146.52l-.05-.23-7.69-28.93h-9.81l-7.75,29.16,0,.11c-.72,2.41.49,4.87,3.59,6.72,5,3,13.16,3,18.19,0C254.16,151.5,255.34,148.93,254.62,146.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,156.12a18.51,18.51,0,0,1-9.35-2.33c-3.24-1.94-4.63-4.6-3.82-7.31l0-.07,7.85-29.56h10.6l7.85,29.54c.81,2.72-.61,5.49-3.79,7.4A18.55,18.55,0,0,1,242,156.12Zm-4.51-38.24-7.67,28.87c-.67,2.25.55,4.48,3.35,6.16,4.87,2.93,12.79,2.93,17.66,0,2.76-1.65,4-4,3.33-6.24l-.06-.26-7.59-28.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.44,115.28c1.92,1.15,1.92,3,0,4.16a7.41,7.41,0,0,1-6.94,0c-1.91-1.15-1.91-3,0-4.16A7.41,7.41,0,0,1,245.44,115.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,120.83a7.36,7.36,0,0,1-3.73-1,2.73,2.73,0,0,1,0-5,7.85,7.85,0,0,1,7.47,0h0a2.73,2.73,0,0,1,0,5A7.37,7.37,0,0,1,242,120.83Zm0-5.91a6.33,6.33,0,0,0-3.2.8,1.73,1.73,0,0,0,0,3.28,6.86,6.86,0,0,0,6.41,0,1.73,1.73,0,0,0,0-3.28A6.4,6.4,0,0,0,242,114.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.15,116.28a5.92,5.92,0,0,0-4.38,0c-1.22.57-1.22,1.48,0,2a5.92,5.92,0,0,0,4.38,0C245.36,117.76,245.36,116.85,244.15,116.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,119.27a5.76,5.76,0,0,1-2.41-.48c-1.05-.48-1.21-1.14-1.21-1.48s.16-1,1.21-1.49a6.38,6.38,0,0,1,4.82,0h0c1,.49,1.2,1.14,1.2,1.49s-.15,1-1.2,1.48A5.79,5.79,0,0,1,242,119.27Zm0-2.89a4.89,4.89,0,0,0-2,.37c-.42.2-.61.42-.61.56s.19.36.61.55a5.41,5.41,0,0,0,4,0c.42-.19.61-.42.61-.55s-.19-.36-.61-.56A4.89,4.89,0,0,0,242,116.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.39,130.57l-1.64-6.14h0c.27,1.23-.37,2.51-1.93,3.45a10.34,10.34,0,0,1-9.67,0c-1.57-.94-2.21-2.22-1.94-3.45h0l-1.15,4.35-.53,2c-.46,1.6.33,3.3,2.39,4.53a13,13,0,0,0,12.17,0C250.23,134.05,251,132.27,250.39,130.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,137.36a12.6,12.6,0,0,1-6.35-1.58c-2.18-1.31-3.15-3.22-2.61-5.11l1.77-6.75h1l-.13.62c-.23,1.06.39,2.11,1.7,2.9a9.79,9.79,0,0,0,9.14,0c1.32-.79,1.93-1.84,1.7-2.9l-.13-.62h1l.11.38,1.63,6.13c.67,2-.28,4-2.54,5.35A12.6,12.6,0,0,1,242,137.36Zm-6.86-10.68L234,130.94c-.41,1.45.38,2.89,2.16,4a12.42,12.42,0,0,0,11.64,0c1.85-1.11,2.62-2.63,2.09-4.16v0l-1.07-4a5.08,5.08,0,0,1-1.75,1.65,10.89,10.89,0,0,1-10.2,0A5.11,5.11,0,0,1,235.13,126.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.81,143.49h0l-.09-.32a.09.09,0,0,0,0,0l-1.52-5.61h0c.36,1.81-.61,3.71-2.94,5.1a15.57,15.57,0,0,1-14.59,0c-2.32-1.39-3.29-3.29-2.94-5.1h0l-1.57,6h0c-.51,2.16.61,4.43,3.37,6.09,4.67,2.8,12.24,2.8,16.91,0C253.2,147.92,254.32,145.65,253.81,143.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242,152.18a17.3,17.3,0,0,1-8.72-2.16c-2.6-1.56-3.94-3.77-3.71-6h-.06l.15-.65,1.67-6.37h1l-.11.61c-.33,1.68.65,3.35,2.7,4.57a15,15,0,0,0,14.06,0c2-1.22,3-2.89,2.7-4.57l-.12-.61h1l.11.38,1.79,6.64h-.07c.23,2.24-1.12,4.45-3.71,6A17.35,17.35,0,0,1,242,152.18Zm-11.27-8.84-.06.27c-.48,2,.67,4,3.14,5.53,4.51,2.71,11.86,2.71,16.38,0,2.47-1.49,3.61-3.5,3.13-5.53l-.07-.31-.87-3.2a7,7,0,0,1-2.85,3,16.12,16.12,0,0,1-15.12,0,6.93,6.93,0,0,1-2.84-2.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.99,
    y: 133.5,
    width: 23.95,
    height: 1.03,
    transform: "translate(54.39 335.67) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.73,
    y: 129.54,
    width: 2.21,
    height: 1.03,
    transform: "translate(59.09 333.55) rotate(-77.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.43,
    y: 144,
    width: 2.44,
    height: 1.03,
    transform: "translate(42.47 341.81) rotate(-77.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.83,116.29c-1.14.54-1.14,1.4,0,1.93a4.34,4.34,0,0,0,.86.28L241,116A4.56,4.56,0,0,0,239.83,116.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.14,119.12l-.55-.12a4.43,4.43,0,0,1-1-.31c-1-.47-1.16-1.1-1.16-1.43s.15-1,1.16-1.43a4.88,4.88,0,0,1,1.3-.37l.67-.1Zm-.73-2.5a3,3,0,0,0-.36.14h0c-.44.21-.56.41-.56.5s.12.29.56.5a1,1,0,0,0,.21.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 244.36,
    y: 121.73,
    width: 1.03,
    height: 2.72,
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -14.81, 35.47)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.47,
    y: 206.26,
    width: 55.03,
    height: 0.59,
    transform: "translate(-80.58 112) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 143.08,
    y: 207.12,
    width: 55.03,
    height: 0.59,
    transform: "translate(-80.8 112.96) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 144.54,
    y: 208.04,
    width: 55.03,
    height: 0.59,
    transform: "translate(-81.05 113.77) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.19,
    y: 208.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-81.26 114.73) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.55,
    y: 209.82,
    width: 55.03,
    height: 0.59,
    transform: "translate(-81.55 115.51) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.16,
    y: 210.68,
    width: 55.03,
    height: 0.59,
    transform: "translate(-81.78 116.49) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.62,
    y: 211.6,
    width: 55.03,
    height: 0.59,
    transform: "translate(-82.03 117.32) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 152.27,
    y: 212.44,
    width: 55.03,
    height: 0.59,
    transform: "translate(-82.22 118.22) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 153.73,
    y: 213.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-82.5 119.13) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.37,
    y: 214.21,
    width: 55.03,
    height: 0.59,
    transform: "translate(-82.7 120.03) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.83,
    y: 215.13,
    width: 55.03,
    height: 0.59,
    transform: "translate(-82.97 120.9) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 158.48,
    y: 215.97,
    width: 55.03,
    height: 0.59,
    transform: "translate(-83.15 121.79) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.83,
    y: 216.92,
    width: 55.03,
    height: 0.59,
    transform: "translate(-83.47 122.66) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 161.44,
    y: 217.78,
    width: 55.03,
    height: 0.59,
    transform: "translate(-83.66 123.51) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 162.91,
    y: 218.69,
    width: 55.03,
    height: 0.59,
    transform: "translate(-83.92 124.37) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 164.55,
    y: 219.53,
    width: 55.03,
    height: 0.59,
    transform: "translate(-84.13 125.34) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 166.01,
    y: 220.45,
    width: 55.03,
    height: 0.59,
    transform: "translate(-84.38 126.15) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.91,
    y: 193.9,
    width: 55.03,
    height: 0.59,
    transform: "translate(-77.28 99.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.56,
    y: 194.74,
    width: 55.03,
    height: 0.59,
    transform: "translate(-77.5 100.55) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.91,
    y: 195.68,
    width: 55.03,
    height: 0.59,
    transform: "translate(-77.77 101.32) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.53,
    y: 196.54,
    width: 55.03,
    height: 0.59,
    transform: "translate(-78 102.27) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.99,
    y: 197.46,
    width: 55.03,
    height: 0.59,
    transform: "translate(-78.25 103.09) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.64,
    y: 198.3,
    width: 55.03,
    height: 0.59,
    transform: "translate(-78.46 104.06) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 129.1,
    y: 199.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-78.71 104.88) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.74,
    y: 200.07,
    width: 55.03,
    height: 0.59,
    transform: "translate(-78.94 105.85) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.2,
    y: 200.99,
    width: 55.03,
    height: 0.59,
    transform: "translate(-79.18 106.67) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.84,
    y: 201.83,
    width: 55.03,
    height: 0.59,
    transform: "translate(-79.39 107.62) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.2,
    y: 202.78,
    width: 55.03,
    height: 0.59,
    transform: "translate(-79.67 108.4) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 136.81,
    y: 203.64,
    width: 55.03,
    height: 0.59,
    transform: "translate(-79.9 109.34) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.28,
    y: 204.55,
    width: 55.03,
    height: 0.59,
    transform: "translate(-80.15 110.18) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.92,
    y: 205.39,
    width: 55.03,
    height: 0.59,
    transform: "translate(-80.35 111.11) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.38,
    y: 206.31,
    width: 55.03,
    height: 0.59,
    transform: "translate(-80.63 112.02) rotate(-29.98)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228,84.05,84.57,1.23A3.49,3.49,0,0,0,81.22.86h0l0,0A45.62,45.62,0,0,0,72.3,6.1l6.89,6.72v103c0,4,2.41,8.57,5.38,10.29l139.35,80.45-4.86,2.39,3.52,5.51a26.31,26.31,0,0,0,9.18-5.39c1-.72,1.65-2.19,1.65-4.21V94.34C233.41,90.37,231,85.77,228,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.31,215.12l-4.1-6.43,4.45-2.2L84.28,126.6c-3.13-1.81-5.68-6.65-5.68-10.8V13.07l-7.19-7,.52-.41a46.34,46.34,0,0,1,9-5.29,4.17,4.17,0,0,1,4,.36L228.32,83.54c3.13,1.8,5.68,6.65,5.68,10.8v110.5c0,2.15-.67,3.82-1.89,4.69a26.73,26.73,0,0,1-9.37,5.48Zm-2.39-6,2.91,4.56a27.2,27.2,0,0,0,8.55-5.13,4.51,4.51,0,0,0,1.44-3.76V94.34c0-3.77-2.28-8.16-5.09-9.78L84.28,1.74a3,3,0,0,0-2.8-.35l-.08,0a46.82,46.82,0,0,0-8.19,4.73l6.57,6.41V115.8c0,3.77,2.28,8.15,5.09,9.77l140.3,81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "79.25 22.79 79.25 60.83 170.84 113.72 224.71 82.13 100.61 10.46 79.25 22.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.84,114.4,78.66,61.18V22.45l22-12.68.3.17,125,72.19Zm-91-53.91,91,52.54,52.69-30.89-122.92-71-20.77,12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.39 11.13 79.13 12.82 79.13 16.15 94.38 6.93 86.97 2.65 78.1 7.67 77.39 11.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.53,17.2V13.07l-1.78-1.74.83-4L87,2l8.58,5ZM78,10.93l1.68,1.64V15.1l13.5-8.16L87,3.33,78.63,8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.81,208.32a4.93,4.93,0,0,0-2.43-3.21l-5.57-3.22c-5.68-3.28-10.32-11.32-10.32-17.88V147a.14.14,0,0,0-.07-.11l-5.61-3.24a.12.12,0,0,0-.18.15,15,15,0,0,1,.68,4.31v26.8a8,8,0,0,1-.95,4l-.57-4.38a.13.13,0,0,0-.15-.11L154,175.83a.15.15,0,0,1-.12-.05,19.09,19.09,0,0,1-4.15-11V138a8.26,8.26,0,0,1,.74-3.62.14.14,0,0,0-.05-.16l-5.66-3.27a.13.13,0,0,0-.2.11v36.69c0,6.64-4.7,9.36-10.45,6l-5.81-3.36c-.61-.35-1-.43-1.42-.18l-.12.05a51.84,51.84,0,0,0-10.86,6.33.13.13,0,0,0,0,.2l4.37,3.91,0,0,53.66,29.81s0,0,0,0l5.25,6.16a.13.13,0,0,0,.14,0c.78-.29,7.26-2.76,11.08-6.52A2,2,0,0,0,190.81,208.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.33,217.38a.73.73,0,0,1-.55-.25l-5.2-6.11-53.65-29.8-.07-.06-4.38-3.91a.71.71,0,0,1-.24-.56.73.73,0,0,1,.28-.55,52.29,52.29,0,0,1,11-6.41l.07,0a1.88,1.88,0,0,1,2,.2l5.8,3.35c2.59,1.5,5,1.75,6.79.72s2.78-3.25,2.78-6.24V131a.73.73,0,0,1,.36-.62.71.71,0,0,1,.72,0l5.66,3.27a.71.71,0,0,1,.29.93,7.66,7.66,0,0,0-.67,3.36v26.79a18.33,18.33,0,0,0,3.86,10.44l11.39-1.33a.73.73,0,0,1,.8.63l.25,1.87a9.53,9.53,0,0,0,.1-1.45v-26.8a14.42,14.42,0,0,0-.66-4.14.73.73,0,0,1,.24-.78.71.71,0,0,1,.8-.05l5.62,3.24a.73.73,0,0,1,.36.62v37c0,6.38,4.5,14.17,10,17.37l5.57,3.21a5.52,5.52,0,0,1,2.71,3.61h0a2.49,2.49,0,0,1-.54,2.49c-3.9,3.84-10.53,6.37-11.27,6.65A.77.77,0,0,1,179.33,217.38Zm-58.72-37.14,53.71,29.84.1.11,5.05,5.92c1.5-.58,7.15-2.91,10.56-6.27a1.55,1.55,0,0,0,.2-1.4h0a4.34,4.34,0,0,0-2.14-2.82l-5.58-3.22c-5.85-3.38-10.62-11.63-10.62-18.39V147.29l-4.4-2.55a14.75,14.75,0,0,1,.42,3.39v26.8a8.41,8.41,0,0,1-1,4.33l-.88,1.49-.73-5.64-11.2,1.31a.74.74,0,0,1-.65-.28,19.57,19.57,0,0,1-4.28-11.37V138a9.19,9.19,0,0,1,.62-3.48l-4.61-2.66v35.89c0,3.43-1.19,6-3.36,7.27s-5,1-8-.72l-5.8-3.35c-.59-.34-.74-.25-.82-.2l-.17.08a51.83,51.83,0,0,0-10.32,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.81,208.46c-.14-.68,0-.77-.45-1.31a34.33,34.33,0,0,1-11.1,6.17l-2.76.36,2.73,3.21a.13.13,0,0,0,.14,0c.78-.29,7.26-2.77,11.08-6.52A2.07,2.07,0,0,0,190.81,208.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.33,217.53a.72.72,0,0,1-.55-.26l-3.44-4,3.79-.49A34.16,34.16,0,0,0,190,206.69l.47-.39.38.48a2,2,0,0,1,.49,1.16c0,.11,0,.24.07.4h0a2.51,2.51,0,0,1-.54,2.5c-3.91,3.85-10.53,6.37-11.27,6.64A.79.79,0,0,1,179.33,217.53Zm-1.68-3.41,1.82,2.14c1.51-.59,7.14-2.91,10.56-6.27a1.57,1.57,0,0,0,.2-1.41c0-.2-.06-.35-.08-.48v0a34.24,34.24,0,0,1-10.73,5.8l-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.69,210.48l0,0,1.42,1.66,12.73-7.28-5.32-3.07a16,16,0,0,1-2.35-1.69c-5.3,3-10.45,5.85-12.54,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175,212.93l-1.69-2-6.89-3.83.94-.52c2-1.09,7.2-4,12.54-7l.36-.2.31.26a15.38,15.38,0,0,0,2.27,1.63l6.21,3.59Zm-1-3,.1,0,.12.13,1.09,1.27,11.42-6.52-4.43-2.56a14.86,14.86,0,0,1-2.12-1.48c-4.53,2.58-8.9,5-11.26,6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.1,173.78l-5.81-3.35c-.61-.35-1-.43-1.42-.19l-.12.06a52,52,0,0,0-10.86,6.32.14.14,0,0,0,0,.21l4.37,3.9,0,0,.56.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.66,182.4l-.83-1.25-4.35-3.88a.73.73,0,0,1-.24-.57.71.71,0,0,1,.29-.55,52.3,52.3,0,0,1,11-6.4l.07,0a1.88,1.88,0,0,1,2,.21l6.68,3.86Zm0-2.14.08,0,.34.51,11.89-7L128,170.94c-.59-.34-.74-.25-.82-.2l-.17.09a52.06,52.06,0,0,0-10.32,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.49,184V169.69c-2.39-.82-4.19-1.41-4.38-1.41a5.15,5.15,0,0,0-.8.2v6.45a8,8,0,0,1-.95,4l-.57-4.38a.13.13,0,0,0-.15-.11L154,175.83a.15.15,0,0,1-.12-.05,22.91,22.91,0,0,1-1.63-2.47l-.51.17,1.27,25,6.15,3.71.16.22,5,2.78.72-.93s6.19-3.38,12.42-7.23C174.49,193.23,172.49,188.3,172.49,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.47,206l-5.55-3.08-.18-.23-6.31-3.82-1.31-25.77,1.4-.46.23.42a23.63,23.63,0,0,0,1.43,2.19l11.39-1.33a.73.73,0,0,1,.8.63l.25,1.87a9.53,9.53,0,0,0,.1-1.45V168l.43-.12a4.11,4.11,0,0,1,1-.22c.16,0,.35,0,4.57,1.44l.4.14V184c0,4,1.85,8.83,4.84,12.67l.41.52-.56.35c-5.73,3.53-11.49,6.71-12.34,7.18Zm-4.76-4,4.45,2.48.49-.63.11-.06c.06,0,5.88-3.22,11.83-6.87a22.73,22.73,0,0,1-4.7-12.87v-13.9c-2.74-.93-3.56-1.18-3.79-1.23l-.19.05v6a8.41,8.41,0,0,1-1,4.33l-.88,1.49-.73-5.64-11.2,1.31a.74.74,0,0,1-.65-.28c-.36-.46-.7-.94-1-1.45l1.2,23.46,6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M177.82,211.7l-6-3.47c-5.66-3.27-10.26-11.23-10.26-17.77V153.33l-5.95-3.44a15.28,15.28,0,0,1,.78,4.62v26.8c0,5.61-3.94,7.88-8.79,5.07s-8.8-9.62-8.8-15.23V144.36a8.3,8.3,0,0,1,.78-3.72l-6-3.44v37.13c0,6.55-4.6,9.2-10.26,5.93l-6-3.47c-1.18-.68-2.14-.13-2.14,1.24a4.73,4.73,0,0,0,2.14,3.71l60.45,34.9c1.19.69,2.15.13,2.15-1.23A4.71,4.71,0,0,0,177.82,211.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.78,217.53a2.49,2.49,0,0,1-1.25-.37l-60.46-34.91a5.33,5.33,0,0,1-2.44-4.22,1.89,1.89,0,0,1,3-1.75l6,3.46c2.55,1.48,4.91,1.73,6.66.72s2.71-3.18,2.71-6.13V136.17l7.32,4.23-.25.5a7.62,7.62,0,0,0-.72,3.46v26.79c0,5.41,3.82,12,8.5,14.72,2.16,1.25,4.16,1.47,5.63.62s2.28-2.69,2.28-5.18v-26.8a14.74,14.74,0,0,0-.76-4.44l-.46-1.46,7.58,4.37v37.48c0,6.35,4.46,14.09,10,17.26l6,3.46a5.32,5.32,0,0,1,2.44,4.23,2.07,2.07,0,0,1-.93,1.9A1.66,1.66,0,0,1,178.78,217.53Zm-62.37-40.44a.44.44,0,0,0-.26.07,1,1,0,0,0-.33.87,4.15,4.15,0,0,0,1.84,3.2l60.46,34.9a.74.74,0,0,0,1.25-.72,4.15,4.15,0,0,0-1.84-3.2l-6-3.47c-5.82-3.36-10.56-11.56-10.56-18.28V153.67l-4.41-2.55a14.75,14.75,0,0,1,.42,3.39v26.8c0,2.93-1,5.13-2.87,6.2s-4.27.85-6.81-.61c-5-2.9-9.09-10-9.09-15.75V144.36a9.36,9.36,0,0,1,.61-3.48l-4.6-2.66v36.11c0,3.39-1.17,5.93-3.3,7.16s-4.92,1-7.85-.72l-6-3.47A1.36,1.36,0,0,0,116.41,177.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.78,144.44v26.8c0,5.61,3.94,12.43,8.79,15.23s8.8.53,8.8-5.08V154.6a15.37,15.37,0,0,0-.79-4.63l3.13,1.8V141.52H139.23A8.87,8.87,0,0,0,138.78,144.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.5,188.27a8.5,8.5,0,0,1-4.22-1.29c-5-2.89-9.09-9.95-9.09-15.74v-26.8a9.51,9.51,0,0,1,.48-3.12l.13-.39h20.5V152.8l-2.76-1.59a14.68,14.68,0,0,1,.42,3.39v26.79c0,2.94-1,5.14-2.87,6.21A5.1,5.1,0,0,1,151.5,188.27Zm-11.84-46.16a8.9,8.9,0,0,0-.29,2.33v26.8c0,5.41,3.81,12,8.5,14.72,2.16,1.24,4.16,1.46,5.63.61s2.28-2.69,2.28-5.18V154.6a14.8,14.8,0,0,0-.76-4.45l-.46-1.46,3.56,2.06v-8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.73,141.52h-12.5a8.87,8.87,0,0,0-.45,2.92v26.8c0,4.16,2.17,9,5.28,12.36,3.14.25,5.33-2.07,5.33-6.26V150.55a15.35,15.35,0,0,0-.78-4.63l3.12,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.52,184.21l-.5,0-.23,0-.16-.17c-3.31-3.57-5.44-8.58-5.44-12.76v-26.8a9.51,9.51,0,0,1,.48-3.12l.13-.39h13.52v7.82l-2.76-1.59a14.62,14.62,0,0,1,.42,3.39v26.79a7.32,7.32,0,0,1-2,5.57A5,5,0,0,1,144.52,184.21Zm-.18-1.19a3.8,3.8,0,0,0,2.83-1,6.24,6.24,0,0,0,1.63-4.7V150.55a14.8,14.8,0,0,0-.76-4.45l-.46-1.46,3.56,2.06v-4.59H139.66a8.9,8.9,0,0,0-.29,2.33v26.8C139.37,175.07,141.32,179.67,144.34,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.77,143v26.8c0,5.61,3.93,12.43,8.79,15.23a7.68,7.68,0,0,0,4.31,1.18,7.18,7.18,0,0,0,1.5-4.81V154.6a15.37,15.37,0,0,0-.79-4.63l3.13,1.8V149c-.05-.16-.09-.32-.14-.48l.14.08v-7.08H141.87A9.8,9.8,0,0,0,141.77,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.48,186.81a8.57,8.57,0,0,1-4.22-1.28c-5-2.89-9.09-10-9.09-15.74V143a11.57,11.57,0,0,1,.11-1.56l.08-.5H159.3V152.8l-2.76-1.59a14.68,14.68,0,0,1,.42,3.39v26.79a7.72,7.72,0,0,1-1.65,5.2l-.16.18-.24,0Zm-12.08-44.7a8.64,8.64,0,0,0,0,.88v26.8c0,5.41,3.81,12,8.5,14.72a7.41,7.41,0,0,0,3.72,1.11,6.82,6.82,0,0,0,1.2-4.23V154.6a14.8,14.8,0,0,0-.76-4.45l-.46-1.46,3.56,2.06,0-1.78c0-.09-.05-.18-.08-.27l-.47-1.46.58.34v-5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.29,108.75l-1.64,79.5,31.53,18.2,10.23-5.87V94.68a13.67,13.67,0,0,0-2.48-7.47L213.22,97.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.18,207.14l-32.13-18.56v-.35l1.65-79.83,20.22-11.53L231.1,86.42l.31.45A14.26,14.26,0,0,1,234,94.68V200.93Zm-30.93-19.23,30.93,17.86,9.64-5.53V94.68A12.92,12.92,0,0,0,230.74,88L213.52,97.9l-19.64,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.32,214,75.87,131.21c-3-1.72-5.38-6.33-5.38-10.29V10.42c0-4,2.41-5.79,5.38-4.07L219.32,89.17c3,1.72,5.39,6.32,5.39,10.29V210C224.71,213.92,222.29,215.75,219.32,214Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.46,215.27a4.92,4.92,0,0,1-2.43-.73L75.57,131.72c-3.13-1.81-5.68-6.65-5.68-10.8V10.42c0-2.3.79-4.08,2.16-4.87a4.06,4.06,0,0,1,4.12.28L219.62,88.66c3.13,1.8,5.68,6.65,5.68,10.8V210c0,2.3-.79,4.07-2.16,4.87A3.37,3.37,0,0,1,221.46,215.27ZM73.73,6.3a2.13,2.13,0,0,0-1.09.28c-1,.57-1.56,2-1.56,3.84v110.5c0,3.77,2.28,8.15,5.09,9.77l143.45,82.83a2.93,2.93,0,0,0,2.93.28c1-.57,1.56-2,1.56-3.84V99.46c0-3.77-2.28-8.16-5.08-9.78L75.57,6.86A3.77,3.77,0,0,0,73.73,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.84,202.29,76.35,120a3.68,3.68,0,0,1-1.53-2.94V12.7c0-1.13.68-1.66,1.53-1.16L218.84,93.8a3.67,3.67,0,0,1,1.54,2.94V201.13C220.38,202.26,219.69,202.78,218.84,202.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.45,203.07a1.8,1.8,0,0,1-.91-.27L76.06,120.54a4.27,4.27,0,0,1-1.84-3.45V12.7a2,2,0,0,1,.83-1.76,1.57,1.57,0,0,1,1.6.08L219.13,93.29A4.27,4.27,0,0,1,221,96.74V201.13a1.91,1.91,0,0,1-.83,1.75A1.28,1.28,0,0,1,219.45,203.07Zm-.32-1.29c.09.05.3.15.42.08s.23-.32.23-.73V96.74a3.14,3.14,0,0,0-1.24-2.43L76.06,12.05c-.09-.05-.29-.15-.42-.08s-.23.32-.23.73V117.09a3.16,3.16,0,0,0,1.24,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.17,201.46,77.69,119.2a3.69,3.69,0,0,1-1.54-2.94V11.87a2.72,2.72,0,0,1,0-.42c-.76-.32-1.36.19-1.36,1.24V117.08A3.67,3.67,0,0,0,76.37,120l142.49,82.27c.73.42,1.34.09,1.5-.75A1,1,0,0,1,220.17,201.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.47,203.06a1.85,1.85,0,0,1-.91-.26L76.08,120.54a4.29,4.29,0,0,1-1.84-3.46V12.69A2,2,0,0,1,75,11a1.5,1.5,0,0,1,1.43-.09l.44.19-.09.47a1.48,1.48,0,0,0,0,.31V116.26A3.12,3.12,0,0,0,78,118.69L220.47,201l.06,0,.46.17-.05.5a1.68,1.68,0,0,1-.89,1.29A1.43,1.43,0,0,1,219.47,203.06ZM75.56,12.07a1.24,1.24,0,0,0-.13.62V117.08a3.14,3.14,0,0,0,1.24,2.43l142.48,82.26a.48.48,0,0,0,.4.09l.06,0L77.39,119.71a4.29,4.29,0,0,1-1.83-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.75,170.8l-10.31-6a2,2,0,0,1-.83-1.59h0c0-.61.37-.9.83-.63l10.31,5.95a2,2,0,0,1,.84,1.6h0C153.59,170.78,153.21,171.06,152.75,170.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.08,171.49a1.23,1.23,0,0,1-.62-.18l-10.32-5.95a2.6,2.6,0,0,1-1.13-2.11,1.33,1.33,0,0,1,.59-1.19,1.14,1.14,0,0,1,1.14.05l10.31,5.95a2.59,2.59,0,0,1,1.13,2.11,1.3,1.3,0,0,1-.59,1.18A1,1,0,0,1,153.08,171.49Zm-10.88-8.32v.08a1.43,1.43,0,0,0,.54,1.08L153,170.25v-.08a1.44,1.44,0,0,0-.53-1.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 225.44,
    y: 197.69,
    width: 7.18,
    height: 1.18,
    transform: "translate(-68.46 141.11) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 163.89,
    y: 194.89,
    width: 10.53,
    height: 1.18,
    transform: "translate(-74.94 110.37) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 141.61,
    y: 178.88,
    width: 2.33,
    height: 1.18,
    transform: "translate(-70.46 95.06) rotate(-29.9)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.46,
    y: 125.84,
    width: 55.03,
    height: 0.59,
    transform: "translate(-56.38 41.89) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.07,
    y: 126.7,
    width: 55.03,
    height: 0.59,
    transform: "translate(-56.59 42.81) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.53,
    y: 127.62,
    width: 55.03,
    height: 0.59,
    transform: "translate(-56.86 43.67) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.18,
    y: 128.46,
    width: 55.03,
    height: 0.59,
    transform: "translate(-57.05 44.6) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.53,
    y: 129.4,
    width: 55.03,
    height: 0.59,
    transform: "translate(-57.35 45.42) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.15,
    y: 130.26,
    width: 55.03,
    height: 0.59,
    transform: "translate(-57.56 46.32) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.61,
    y: 131.18,
    width: 55.03,
    height: 0.59,
    transform: "translate(-57.83 47.19) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.25,
    y: 132.02,
    width: 55.03,
    height: 0.59,
    transform: "translate(-58.02 48.11) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 34.72,
    y: 132.94,
    width: 55.03,
    height: 0.59,
    transform: "translate(-58.28 48.97) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.35,
    y: 133.79,
    width: 55.03,
    height: 0.59,
    transform: "translate(-58.5 49.92) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.82,
    y: 134.71,
    width: 55.03,
    height: 0.59,
    transform: "translate(-58.75 50.76) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.46,
    y: 135.55,
    width: 55.03,
    height: 0.59,
    transform: "translate(-58.96 51.71) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.82,
    y: 136.5,
    width: 55.03,
    height: 0.59,
    transform: "translate(-59.24 52.49) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.43,
    y: 137.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-59.47 53.43) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.89,
    y: 138.27,
    width: 55.03,
    height: 0.59,
    transform: "translate(-59.72 54.27) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.54,
    y: 139.11,
    width: 55.03,
    height: 0.59,
    transform: "translate(-59.93 55.22) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47,
    y: 140.03,
    width: 55.03,
    height: 0.59,
    transform: "translate(-60.17 56.05) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.9,
    y: 113.48,
    width: 55.03,
    height: 0.59,
    transform: "translate(-53.08 29.45) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.55,
    y: 114.32,
    width: 55.03,
    height: 0.59,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -53.29, 30.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.9,
    y: 115.26,
    width: 55.03,
    height: 0.59,
    transform: "translate(-53.57 31.19) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.51,
    y: 116.12,
    width: 55.03,
    height: 0.59,
    transform: "translate(-53.8 32.13) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.98,
    y: 117.04,
    width: 55.03,
    height: 0.59,
    transform: "translate(-54.04 32.96) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.62,
    y: 117.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-54.25 33.9) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.09,
    y: 118.8,
    width: 55.03,
    height: 0.59,
    transform: "translate(-54.51 34.76) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.72,
    y: 119.65,
    width: 55.03,
    height: 0.59,
    transform: "translate(-54.72 35.69) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.19,
    y: 120.57,
    width: 55.03,
    height: 0.59,
    transform: "translate(-54.99 36.56) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.83,
    y: 121.41,
    width: 55.03,
    height: 0.59,
    transform: "translate(-55.18 37.48) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.19,
    y: 122.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-55.47 38.28) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.8,
    y: 123.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-55.69 39.21) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.26,
    y: 124.13,
    width: 55.03,
    height: 0.59,
    transform: "translate(-55.96 40.08) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.91,
    y: 124.97,
    width: 55.03,
    height: 0.59,
    transform: "translate(-56.15 40.99) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.37,
    y: 125.89,
    width: 55.03,
    height: 0.59,
    transform: "translate(-56.41 41.85) rotate(-30)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.8,123.52H63.6l-17.32-10a3.91,3.91,0,0,0-3.5-.15L25.35,123.43h0l-1.3.07a.09.09,0,0,0-.09.09v1.12h0a1.37,1.37,0,0,0,.85,1.2l17.75,10.25a3.88,3.88,0,0,0,3.5.15l18.25-10.54a1,1,0,0,0,.59-.81v-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,137.18a4.61,4.61,0,0,1-2.23-.56L24.52,126.37A2,2,0,0,1,23.44,125h0v-1.4A.61.61,0,0,1,24,123l1.19-.06,17.34-10a4.41,4.41,0,0,1,4,.15L63.76,123h1.48l.16,1.09V125a1.6,1.6,0,0,1-.85,1.25L46.29,136.76A3.64,3.64,0,0,1,44.5,137.18ZM24.44,124.44h0l0,.31c0,.23.21.5.59.72l17.75,10.25a3.37,3.37,0,0,0,3,.14L64,125.34c.14-.09.32-.23.33-.41V124H63.5l-.16-.08L46,114a3.4,3.4,0,0,0-3-.14L25.5,123.93l-.17,0-.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.28,124.46,46,135a3.91,3.91,0,0,1-3.5-.15L24.78,124.6c-1-.6-1.15-1.5-.25-2L42.78,112a3.88,3.88,0,0,1,3.5.15L64,122.44C65.07,123,65.18,123.94,64.28,124.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,135.86a4.61,4.61,0,0,1-2.23-.56L24.52,125.05a1.93,1.93,0,0,1-1.11-1.59,1.52,1.52,0,0,1,.86-1.32L42.52,111.6a4.41,4.41,0,0,1,4,.14L64.29,122a2,2,0,0,1,1.11,1.59,1.54,1.54,0,0,1-.86,1.32L46.29,135.44A3.67,3.67,0,0,1,44.5,135.86Zm-.21-23.66a2.61,2.61,0,0,0-1.26.29L24.78,123c-.13.07-.35.23-.35.43s.16.44.6.7l17.75,10.25a3.4,3.4,0,0,0,3,.14L64,124c.13-.07.35-.23.35-.43s-.16-.44-.61-.7L46,112.63A3.58,3.58,0,0,0,44.29,112.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 44.01,
    y: 135.48,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 25.1,
    y: 125.18,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.62,
    y: 126.53,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.96,
    y: 125.07,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.07,120.46l-.06-.23L49.32,91.3H39.51l-7.75,29.16,0,.11c-.72,2.41.49,4.87,3.58,6.72,5,3,13.17,3,18.19,0C56.61,125.44,57.79,122.87,57.07,120.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.42,130.06a18.55,18.55,0,0,1-9.36-2.33c-3.23-1.94-4.62-4.6-3.81-7.31v-.07l7.86-29.56h10.6l7.84,29.54c.81,2.73-.6,5.49-3.79,7.4A18.51,18.51,0,0,1,44.42,130.06ZM39.91,91.82l-7.67,28.87c-.67,2.25.55,4.48,3.35,6.16,4.87,2.93,12.79,2.93,17.66,0,2.76-1.65,4-4,3.32-6.24l-.06-.26L48.93,91.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.89,89.22c1.91,1.15,1.91,3,0,4.16a7.41,7.41,0,0,1-6.94,0c-1.92-1.15-1.92-3,0-4.16A7.41,7.41,0,0,1,47.89,89.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.42,94.77a7.37,7.37,0,0,1-3.74-1,2.73,2.73,0,0,1,0-5,7.85,7.85,0,0,1,7.47,0h0a2.73,2.73,0,0,1,0,5A7.36,7.36,0,0,1,44.42,94.77Zm0-5.91a6.4,6.4,0,0,0-3.21.8A2.05,2.05,0,0,0,40,91.3,2.08,2.08,0,0,0,41.21,93a6.89,6.89,0,0,0,6.41,0,2.07,2.07,0,0,0,1.19-1.65,2,2,0,0,0-1.19-1.64h0A6.33,6.33,0,0,0,44.42,88.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.6,90.22a6,6,0,0,0-4.39,0c-1.21.57-1.21,1.48,0,2a6,6,0,0,0,4.39,0C47.81,91.7,47.81,90.79,46.6,90.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.4,93.21A5.83,5.83,0,0,1,42,92.73c-1-.48-1.2-1.14-1.2-1.48s.16-1,1.2-1.49a6.38,6.38,0,0,1,4.82,0c1,.49,1.21,1.14,1.21,1.49s-.16,1-1.21,1.48A5.76,5.76,0,0,1,44.4,93.21Zm0-2.89a4.81,4.81,0,0,0-2,.37c-.43.2-.61.42-.61.56s.18.36.61.55a5.39,5.39,0,0,0,4,0c.42-.19.61-.42.61-.55s-.19-.36-.61-.56A4.89,4.89,0,0,0,44.4,90.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.83,104.51,51.2,98.37h0c.27,1.23-.37,2.51-1.94,3.45a10.34,10.34,0,0,1-9.67,0c-1.56-.94-2.2-2.22-1.93-3.45h0l-1.15,4.35-.53,2c-.45,1.6.34,3.3,2.39,4.53a13,13,0,0,0,12.17,0C52.68,108,53.41,106.21,52.83,104.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.44,111.3a12.6,12.6,0,0,1-6.35-1.58c-2.18-1.31-3.16-3.22-2.62-5.11l1.78-6.75h1l-.13.62c-.23,1.06.38,2.11,1.7,2.9a9.79,9.79,0,0,0,9.14,0c1.31-.79,1.93-1.84,1.7-2.9l-.14-.62h1l.11.38,1.63,6.13c.68,2-.27,4-2.53,5.35A12.6,12.6,0,0,1,44.44,111.3Zm-6.86-10.68-1.12,4.26c-.41,1.45.37,2.89,2.16,4a12.42,12.42,0,0,0,11.64,0c1.85-1.11,2.61-2.63,2.09-4.16v0l-1.08-4a5.14,5.14,0,0,1-1.74,1.65,10.89,10.89,0,0,1-10.2,0A5.11,5.11,0,0,1,37.58,100.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.26,117.43h0l-.09-.32a.09.09,0,0,1,0,0l-1.52-5.62h0c.36,1.82-.62,3.72-2.94,5.11a15.57,15.57,0,0,1-14.59,0c-2.32-1.39-3.3-3.29-2.94-5.11h0l-1.57,6h0c-.5,2.16.61,4.43,3.38,6.09,4.67,2.8,12.24,2.8,16.91,0C55.65,121.86,56.76,119.59,56.26,117.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.43,126.12A17.33,17.33,0,0,1,35.71,124c-2.59-1.56-3.94-3.77-3.71-6h-.06l.15-.65,1.67-6.37h1l-.11.61c-.33,1.68.66,3.35,2.7,4.57a15,15,0,0,0,14.06,0c2-1.22,3-2.89,2.71-4.57l-.13-.61h1l.11.38,1.8,6.64h-.08c.23,2.24-1.12,4.45-3.71,6A17.3,17.3,0,0,1,44.43,126.12Zm-11.27-8.84-.06.27c-.47,2,.67,4,3.14,5.53,4.52,2.71,11.87,2.71,16.38,0,2.47-1.49,3.61-3.5,3.14-5.53l-.08-.31-.86-3.2A6.93,6.93,0,0,1,52,117a16.1,16.1,0,0,1-15.11,0A7,7,0,0,1,34,114.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.43,
    y: 107.44,
    width: 23.95,
    height: 1.03,
    transform: "translate(-75.27 122.27) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 38.17,
    y: 103.48,
    width: 2.21,
    height: 1.03,
    transform: "translate(-70.71 120.09) rotate(-77.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 34.88,
    y: 117.94,
    width: 2.44,
    height: 1.03,
    transform: "translate(-87.33 128.34) rotate(-77.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.28,90.23c-1.14.54-1.14,1.4,0,1.93a4.13,4.13,0,0,0,.86.28l.31-2.53A4.45,4.45,0,0,0,42.28,90.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.58,93.06,43,92.94a4.61,4.61,0,0,1-1-.31c-1-.47-1.15-1.1-1.15-1.43s.15-1,1.15-1.43h0a5,5,0,0,1,1.31-.37l.67-.1ZM42.5,90.7c-.45.21-.56.41-.56.5s.11.29.56.5l.2.08.15-1.22a2.32,2.32,0,0,0-.35.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.67,
    y: 96.15,
    width: 1.03,
    height: 8.54,
    transform: "translate(-20.78 13.2) rotate(-12.64)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.07,
    y: 238.93,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.24 77.71) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 65.69,
    y: 239.79,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.47 78.66) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 67.15,
    y: 240.71,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.75 79.53) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.79,
    y: 241.55,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.92 80.43) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 70.15,
    y: 242.49,
    width: 55.03,
    height: 0.59,
    transform: "translate(-108.24 81.27) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 71.76,
    y: 243.35,
    width: 55.03,
    height: 0.59,
    transform: "translate(-108.42 82.14) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 73.23,
    y: 244.27,
    width: 55.03,
    height: 0.59,
    transform: "translate(-108.7 83.03) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.87,
    y: 245.11,
    width: 55.03,
    height: 0.59,
    transform: "translate(-108.88 83.93) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 76.33,
    y: 246.03,
    width: 55.03,
    height: 0.59,
    transform: "translate(-109.17 84.81) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.97,
    y: 246.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-109.37 85.74) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.44,
    y: 247.8,
    width: 55.03,
    height: 0.59,
    transform: "translate(-109.64 86.6) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.08,
    y: 248.64,
    width: 55.03,
    height: 0.59,
    transform: "translate(-109.84 87.53) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.44,
    y: 249.59,
    width: 55.03,
    height: 0.59,
    transform: "translate(-110.13 88.34) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.05,
    y: 250.44,
    width: 55.03,
    height: 0.59,
    transform: "translate(-110.34 89.26) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 85.51,
    y: 251.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-110.6 90.11) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.16,
    y: 252.2,
    width: 55.03,
    height: 0.59,
    transform: "translate(-110.8 91.05) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.62,
    y: 253.12,
    width: 55.03,
    height: 0.59,
    transform: "translate(-111.04 91.87) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.52,
    y: 226.57,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.94 65.29) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 44.16,
    y: 227.41,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.17 66.25) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 45.52,
    y: 228.35,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.46 67.06) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.13,
    y: 229.21,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.67 67.98) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.6,
    y: 230.13,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.92 68.82) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.24,
    y: 230.97,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.15 69.78) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.7,
    y: 231.89,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.37 70.59) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.34,
    y: 232.74,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.58 71.53) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.8,
    y: 233.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.86 72.39) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.45,
    y: 234.5,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.06 73.33) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.81,
    y: 235.45,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.33 74.12) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.42,
    y: 236.3,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.58 75.08) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.88,
    y: 237.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.83 75.92) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 62.52,
    y: 238.06,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.01 76.82) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63.99,
    y: 238.98,
    width: 55.03,
    height: 0.59,
    transform: "translate(-107.3 77.71) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.01,
    y: 211.79,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.86 51.1) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.63,
    y: 212.65,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.05 52) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.09,
    y: 213.56,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.31 52.85) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.73,
    y: 214.4,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.53 53.81) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.09,
    y: 215.35,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.83 54.61) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.7,
    y: 216.21,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.01 55.51) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.17,
    y: 217.12,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.29 56.38) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.81,
    y: 217.97,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.52 57.34) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.27,
    y: 218.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.74 58.15) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.91,
    y: 219.74,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.97 59.11) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.38,
    y: 220.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.22 59.95) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.02,
    y: 221.5,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.45 60.91) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.38,
    y: 222.44,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.7 61.68) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.99,
    y: 223.3,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.95 62.63) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.45,
    y: 224.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.18 63.45) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 41.1,
    y: 225.06,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.38 64.38) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.56,
    y: 225.98,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.66 65.26) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -3.54,
    y: 199.42,
    width: 55.03,
    height: 0.59,
    transform: "translate(-96.54 38.66) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.9,
    y: 200.26,
    width: 55.03,
    height: 0.59,
    transform: "translate(-96.74 39.6) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -0.54,
    y: 201.21,
    width: 55.03,
    height: 0.59,
    transform: "translate(-97.03 40.4) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.07,
    y: 202.07,
    width: 55.03,
    height: 0.59,
    transform: "translate(-97.25 41.32) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.54,
    y: 202.98,
    width: 55.03,
    height: 0.59,
    transform: "translate(-97.53 42.19) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.18,
    y: 203.83,
    width: 55.03,
    height: 0.59,
    transform: "translate(-97.71 43.11) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.64,
    y: 204.74,
    width: 55.03,
    height: 0.59,
    transform: "translate(-97.99 43.98) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.28,
    y: 205.6,
    width: 55.03,
    height: 0.59,
    transform: "translate(-98.18 44.89) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.75,
    y: 206.52,
    width: 55.03,
    height: 0.59,
    transform: "translate(-98.46 45.77) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.39,
    y: 207.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-98.67 46.7) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.75,
    y: 208.3,
    width: 55.03,
    height: 0.59,
    transform: "translate(-98.96 47.51) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.36,
    y: 209.16,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.15 48.41) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.82,
    y: 210.08,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.45 49.29) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.47,
    y: 210.92,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.65 50.23) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.93,
    y: 211.84,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.87 51.05) rotate(-29.96)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.52,
    y: 215.27,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.02 94.77) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.13,
    y: 216.13,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.23 95.68) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.59,
    y: 217.04,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.51 96.55) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.24,
    y: 217.88,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.69 97.45) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.59,
    y: 218.83,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.98 98.26) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.21,
    y: 219.69,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.19 99.18) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.67,
    y: 220.6,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.48 100.09) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.31,
    y: 221.44,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.66 100.97) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.78,
    y: 222.36,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.92 101.82) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118.42,
    y: 223.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.14 102.79) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.88,
    y: 224.13,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.4 103.63) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.52,
    y: 224.98,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.61 104.57) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.88,
    y: 225.92,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.88 105.34) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.49,
    y: 226.78,
    width: 55.03,
    height: 0.59,
    transform: "translate(-93.11 106.3) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.95,
    y: 227.7,
    width: 55.03,
    height: 0.59,
    transform: "translate(-93.36 107.12) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.6,
    y: 228.54,
    width: 55.03,
    height: 0.59,
    transform: "translate(-93.58 108.11) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 129.06,
    y: 229.45,
    width: 55.03,
    height: 0.59,
    transform: "translate(-93.84 108.94) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.96,
    y: 202.9,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.72 82.33) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.61,
    y: 203.74,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.93 83.28) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 85.96,
    y: 204.69,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.22 84.08) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.58,
    y: 205.55,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.44 85.02) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 89.04,
    y: 206.46,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.68 85.84) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.68,
    y: 207.31,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.89 86.78) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.15,
    y: 208.22,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.15 87.63) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.79,
    y: 209.08,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.36 88.56) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.25,
    y: 210,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.64 89.45) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 96.89,
    y: 210.84,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.82 90.35) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.25,
    y: 211.78,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.13 91.18) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.86,
    y: 212.64,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.32 92.07) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.32,
    y: 213.56,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.6 92.96) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 102.97,
    y: 214.4,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.8 93.89) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.43,
    y: 215.31,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.07 94.74) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.4,192.47,67.89,153.82s0,0,0,0L48.34,215h0L46,216.42s0,0,0,0l21.91-68.69h0L89.8,191.11h0l-2.38,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.93,217l-.57-.43.11-.36,22-69,.69,0,.16.3L90.47,191.3l-.41.26L87.46,193l-.44-.16-.08-.19L68,155.15l-19.2,60.22-.16.1Zm22.05-68L46.85,215.32l1.06-.62,19.58-61.37.7,0,.16.31,19.27,38.17,1.5-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.58,212.67l6.36,3.76h0l21.91-68.71h0l-6.37-3.76h0L39.57,212.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.9,217l-.21-.12-6.73-4,.12-.38,22-68.95.48-.18.23.14,6.72,4-.16.42-22,68.92Zm-5.72-4.56,5.48,3.24,21.6-67.74-5.47-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81,188.71l6.36,3.75s0,0,0,0l-19.5-38.63s0,0,0,0l-1.73,5.41h0L81,188.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.45,193.1l-.34-.2-6.47-3.8-.08-.16-15-29.65,1.9-6,.7,0,.16.31,19.68,39Zm-6-4.75,4.75,2.8L68,155.15l-1.29,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.34,215.69l6.31,3.72a0,0,0,0,0,0,0l-19.47-38.55a0,0,0,0,0,0,0l-1.72,5.38h0l14.87,29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.75,220.05l-.37-.2L126.91,216l-15-29.8,0-.13,1.82-5.71.71-.06.17.33,19.64,38.88Zm-6-4.73,4.75,2.8-18.18-36-1.29,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.53,178.28,126.64,209h0l1.22-.7h0l-2.22-4.4h0L73.42,174.11h0l-1.22.7,3.34,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.67,209.62l-.26-.12-51.2-30.81,0-.05-3.8-3.95,2-1.17.25.13L126,203.55l2.52,5-.46.24ZM75.85,177.88l50.8,30.57.55-.32-1.94-3.84-51.84-29.6-.41.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.3,179l52.32,30s0,0,0,0l-2.21-4.38h0l-52.2-29.81a0,0,0,0,0,0,0L74.3,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.72,209.66l-.35-.19-52.45-30.1-2.35-4.65.58-.53.33.19,52.33,29.88,2.45,4.85Zm-52-31,50.73,29.12L124,205,73.42,176.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.89,239.64l6.36,3.76h0l21.91-68.72s0,0,0,0l-6.37-3.76h0L85.88,239.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.2,244l-.23-.15-6.72-4,.16-.42,22-68.91.48-.19.23.15,6.72,4-.16.42-22,68.92Zm-5.71-4.57L92,242.64l21.6-67.73-5.47-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.7,219.42l-19.48-38.57a0,0,0,0,0-.06,0L94.66,242l0,0-2.31,1.35a0,0,0,0,1,0,0l21.87-68.58a0,0,0,0,1,.06,0l21.88,43.32s0,0,0,.05l-2.34,1.33S133.71,219.44,133.7,219.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.29,244l-.59-.45.1-.37,22-68.91.72-.07.18.32,22.09,43.76-.43.28L133.81,220l-.44-.12-.13-.22-19-37.52L95.12,242.24l-.12.15-.1.07Zm22-68L93.16,242.29l1.06-.62,19.56-61.31.72-.07.18.33,19.25,38.12,1.5-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.34,200.63,94.74,232h0l1.28-.63h0l1.13-3.67v0L44.5,197h0l-1.28.62h0l.14,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.69,232.59l-.26-.19L42.87,201l0-.26-.15-3.38,1.83-.88.25.13,53,30.9-.16.43-1.17,3.8-.16.11ZM43.84,200.34l50.93,31.07.84-.4.94-3.08L44.47,197.58l-.74.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.05,201.26,94.73,232h0l1.13-3.67h0L43.21,197.64h0l-1.15,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.71,232.56l-.23-.12L41.83,201.72l-.38-.15.1-.44,1.24-3.88.47-.18.22.13,53,30.89-.16.42-1.18,3.85ZM42.66,201l51.78,30.21.82-2.68L43.5,198.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96.32 231.46 95.75 231.27 96.88 227.96 97.44 228.15 96.32 231.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 126.17,
    y: 203.73,
    width: 0.59,
    height: 3.62,
    transform: "translate(-79.07 79.07) rotate(-26.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 68.95,
    y: 151.98,
    width: 0.79,
    height: 6.16,
    transform: "translate(-99.54 136.86) rotate(-59.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.56,191.66l52.65,30.67h0l5.44-17.15h0L51.85,174.83h0l-1.07.3h0l-4.22,16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.16,222.89l-.21-.11L46.27,192.09l-.31-.21.1-.37,4.29-16.8,1.58-.44.21.13,53.1,30.51-.07.37-5.54,17.45Zm-52-31.48,51.78,30.16,5.13-16.16-52.27-30-.58.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.48,192l52.65,30.66h0l5.45-17.15h0L50.78,175.13h0L45.48,192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.07,223.21l-.22-.15-52.6-30.64-.39-.17.13-.44,5.37-17.07.48-.18.23.14,53.16,30.55-.16.42L98.56,223Zm-52-31.49,51.76,30.15L103,205.72,51.07,175.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.72 195.01 71.75 187.18 80.95 192.47 59.48 200.12 50.72 195.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.42,200.68l-9.9-5.77,22.28-8.3,10.37,6Zm-7.51-5.56,7.62,4.43,20.2-7.19-8-4.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "67.75 204.84 88.78 197.01 97.98 202.29 76.51 209.94 67.75 204.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.46,210.51l-9.9-5.77,22.27-8.3,10.38,6ZM69,204.94l7.61,4.44,20.2-7.2-8-4.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "84.78 214.67 102.81 207.96 99.75 217.56 93.54 219.77 84.78 214.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.49,220.34l-9.9-5.77,20-7.46L100.17,218ZM86,214.77l7.62,4.44,5.74-2.05,2.66-8.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.46 179.31 54.71 177.35 63.91 182.64 46.45 188.86 49.46 179.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.66,189.69l3.39-10.78,5.71-2.13,10.38,6Zm4.21-10L47.25,188l15.45-5.5-8-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.1,167l52.64,30.67h0l5.44-17.14h0L59.39,150.2h0l-1.06.3h0L54.09,167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.68,198.28l-.22-.15L53.79,167.45l-.26-.19.06-.33,4.3-16.85,1.6-.44.21.15,53.14,30.53-.16.43-5.51,17.35Zm-52-31.49L106.46,197l5.13-16.16-52.27-30-.58.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53,167.34,105.67,198h0l5.45-17.15h0l-52.8-30.34h0L53,167.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.61,198.58l-.22-.14L52.78,167.79l-.36-.17.1-.41,5.38-17.09.45-.17.2.1,53.15,30.54-.07.37-5.54,17.44Zm-52-31.48,51.75,30.15,5.14-16.16L58.61,151.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.25 170.39 79.29 162.55 88.49 167.84 67.01 175.49 58.25 170.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,176.05l-9.9-5.76L79.33,162l10.38,6Zm-7.51-5.56,7.62,4.44,20.2-7.2-8-4.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.29 180.22 96.32 172.38 105.52 177.67 84.05 185.32 75.29 180.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84,185.88l-9.91-5.77,22.28-8.29,10.37,6Zm-7.52-5.56,7.62,4.44,20.2-7.2-8-4.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "92.32 190.04 110.34 183.33 107.29 192.94 101.08 195.15 92.32 190.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101,195.71l-9.9-5.77,20-7.46-3.45,10.85Zm-7.51-5.56,7.61,4.43,5.75-2,2.66-8.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "57 154.68 62.25 152.72 71.45 158.01 53.99 164.23 57 154.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.19,165.06l3.39-10.77,5.72-2.13,10.37,6Zm4.22-10-2.62,8.33,15.44-5.5-8-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.9,203.17l-29-7a2.26,2.26,0,0,1-1.59-2.45l2.17-17.44a1.74,1.74,0,0,1,2.1-1.59l29.24,6.78a2.26,2.26,0,0,1,1.63,2.49L94.06,201.6A1.76,1.76,0,0,1,91.9,203.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.32,203.73a2.48,2.48,0,0,1-.54-.06l-29-7a2.77,2.77,0,0,1-2-3L63,176.18a2.45,2.45,0,0,1,1-1.7,2.15,2.15,0,0,1,1.74-.33l29.24,6.78A2.78,2.78,0,0,1,97,184l-2.38,17.68a2.43,2.43,0,0,1-1,1.68A2.19,2.19,0,0,1,92.32,203.73Zm-.3-1.06a1.19,1.19,0,0,0,1-.17,1.36,1.36,0,0,0,.57-1l2.38-17.68a1.73,1.73,0,0,0-1.24-1.92l-29.23-6.78a1.11,1.11,0,0,0-.92.17,1.4,1.4,0,0,0-.56,1l-2.17,17.44a1.74,1.74,0,0,0,1.2,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.49,182.18l-.41,3.28a2.13,2.13,0,0,1-.77,1.53,2,2,0,0,1-1.67.2,2.38,2.38,0,0,1-1.5-.94,2.5,2.5,0,0,1-.34-1.76l.42-3.31,1.35.32-.4,3.19a1.46,1.46,0,0,0,.09.88.79.79,0,0,0,.55.4.65.65,0,0,0,.64-.11,1.45,1.45,0,0,0,.29-.81l.4-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.62,189l-1.78-.42-1.34-4.27h0c0,.61-.07,1.08-.11,1.4l-.31,2.45-1.2-.28.69-5.45,1.77.41,1.34,4.23h0c0-.55.07-1,.12-1.33l.31-2.47,1.22.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.36,187.44a2.72,2.72,0,0,1-1,1.94,2.42,2.42,0,0,1-2,.28l-1.63-.39.7-5.46,1.75.41A2.87,2.87,0,0,1,82,185.33,3,3,0,0,1,82.36,187.44Zm-1.43-.29A1.89,1.89,0,0,0,80.8,186a1.14,1.14,0,0,0-.78-.56l-.4-.09-.4,3.06.31.07a1,1,0,0,0,1-.17A1.83,1.83,0,0,0,80.93,187.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.89,191.21l-3-.71.72-5.47,3,.7-.16,1.19-1.64-.38-.11.86,1.51.36L86.07,189l-1.52-.36-.14,1,1.64.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.42,189.76l-.27,2-1.37-.32.73-5.49,1.66.39c1.39.33,2,1,1.86,2.12A1.46,1.46,0,0,1,90,189.72l1.17,2.74-1.56-.37-.81-2.25Zm.15-1.12.25.06c.48.12.75-.06.81-.51s-.16-.63-.63-.74l-.27-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67,189a.33.33,0,0,0-.36.11.93.93,0,0,0-.18.49c-.06.47.07.74.4.81a.7.7,0,0,0,.29,0l.29,0-.07.55a1.44,1.44,0,0,1-.65,0,1.1,1.1,0,0,1-.72-.5,1.45,1.45,0,0,1-.16-1,1.51,1.51,0,0,1,.22-.62.83.83,0,0,1,.42-.35,1.06,1.06,0,0,1,.59,0,1.71,1.71,0,0,1,.67.34l-.25.46-.23-.16A.82.82,0,0,0,67,189Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70,190.46a1.27,1.27,0,0,1-.39.86.93.93,0,0,1-.85.12,1.12,1.12,0,0,1-.75-.51,1.42,1.42,0,0,1-.16-1,1.22,1.22,0,0,1,.39-.85.94.94,0,0,1,.84-.13,1.12,1.12,0,0,1,.76.51A1.47,1.47,0,0,1,70,190.46Zm-1.52-.37c-.06.47.06.74.35.81a.33.33,0,0,0,.36-.09.87.87,0,0,0,.18-.5,1.07,1.07,0,0,0,0-.56.41.41,0,0,0-.32-.25C68.69,189.42,68.51,189.62,68.46,190.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.34,192.27l-.79-.19L71,190.19h0c0,.28,0,.48,0,.62l-.14,1.09-.53-.13.3-2.41.79.19.59,1.87h0c0-.25,0-.44,0-.59l.14-1.09.54.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.37,192a.63.63,0,0,1-.16.37.56.56,0,0,1-.33.2,1,1,0,0,1-.48,0l-.37-.12a1.74,1.74,0,0,1-.3-.2l.08-.58a2.08,2.08,0,0,0,.34.24,1.25,1.25,0,0,0,.33.13.33.33,0,0,0,.2,0,.15.15,0,0,0,.08-.12.14.14,0,0,0,0-.09l-.07-.09-.28-.23a1.39,1.39,0,0,1-.3-.29.75.75,0,0,1-.14-.59.55.55,0,0,1,.29-.47.89.89,0,0,1,.64,0,1.84,1.84,0,0,1,.68.35l-.25.46a1.46,1.46,0,0,0-.52-.29.21.21,0,0,0-.18,0,.1.1,0,0,0-.06.09.18.18,0,0,0,0,.15,2.85,2.85,0,0,0,.34.29,1.17,1.17,0,0,1,.36.4A.76.76,0,0,1,74.37,192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.6,193.05l-.6-.14.24-1.89-.54-.13.07-.53,1.69.4-.07.54-.54-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.18,192.52l-.11.88-.61-.14.32-2.42.73.17c.61.15.88.46.82.94a.65.65,0,0,1-.47.56l.52,1.21-.69-.17-.36-1Zm.07-.49.11,0c.21.05.33,0,.35-.23s-.07-.27-.27-.32l-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.8,191.8l-.19,1.46a.92.92,0,0,1-.34.67.87.87,0,0,1-.76.09,1.09,1.09,0,0,1-.67-.42,1.12,1.12,0,0,1-.15-.79l.19-1.47.61.15-.18,1.42a.66.66,0,0,0,0,.39.37.37,0,0,0,.24.18.31.31,0,0,0,.29,0,.62.62,0,0,0,.13-.36l.18-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.2,192.65a.35.35,0,0,0-.36.11.92.92,0,0,0-.19.5c-.06.47.07.74.4.82a1,1,0,0,0,.3,0,1.55,1.55,0,0,0,.29,0l-.07.56a1.44,1.44,0,0,1-.65,0,1.12,1.12,0,0,1-.74-.5,1.56,1.56,0,0,1-.15-1,1.35,1.35,0,0,1,.22-.63.82.82,0,0,1,.43-.35,1,1,0,0,1,.6,0,1.62,1.62,0,0,1,.67.33l-.25.47-.23-.16A.81.81,0,0,0,82.2,192.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84,195.06l-.6-.14.25-1.89-.55-.14.07-.53,1.7.4-.07.54-.55-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.85,195.27l.32-2.43.61.15-.32,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.22,194.82a1.27,1.27,0,0,1-.4.87,1,1,0,0,1-.86.12,1.21,1.21,0,0,1-.77-.52,1.51,1.51,0,0,1-.16-1,1.27,1.27,0,0,1,.4-.86,1,1,0,0,1,.86-.12,1.16,1.16,0,0,1,.78.51A1.51,1.51,0,0,1,88.22,194.82Zm-1.55-.37q-.09.7.36.81a.34.34,0,0,0,.37-.09.87.87,0,0,0,.18-.5,1.1,1.1,0,0,0,0-.57.43.43,0,0,0-.32-.25C86.92,193.77,86.73,194,86.67,194.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.62,196.65l-.8-.19-.6-1.91h0q0,.42-.06.63l-.14,1.1-.54-.13.32-2.44.8.19.6,1.89h0c0-.24,0-.44.06-.59l.15-1.1.54.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.78,178a.68.68,0,0,1-.82.62.88.88,0,0,1-.62-1,.67.67,0,0,1,.82-.61A.88.88,0,0,1,66.78,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.09,184.4a.7.7,0,0,1-.84.62.88.88,0,0,1-.63-1,.69.69,0,0,1,.84-.62A.87.87,0,0,1,94.09,184.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.8,193.76a.65.65,0,0,1-.81.6.86.86,0,0,1-.61-1,.65.65,0,0,1,.81-.6A.86.86,0,0,1,64.8,193.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92,200.31a.68.68,0,0,1-.84.61.88.88,0,0,1-.62-1,.67.67,0,0,1,.83-.61A.86.86,0,0,1,92,200.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.85,146.64l-11.63-2.25h0l-4.46.59a0,0,0,0,0,0,0v4.11a1.62,1.62,0,0,0,1,1.3l6.24,3.6a4.45,4.45,0,0,0,4,.17l4.25-2.45a1.17,1.17,0,0,0,.68-1v-4.07S71.87,146.64,71.85,146.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.2,155.11a5.19,5.19,0,0,1-2.53-.63l-6.24-3.6a2.14,2.14,0,0,1-1.22-1.75v-4.56l.48-.1,4.56-.6.1,0,12,2.33,0,.46v4.07a1.7,1.7,0,0,1-.94,1.44l-4.25,2.45A4,4,0,0,1,65.2,155.11Zm-9-9.68v3.7c0,.28.27.6.72.86l6.24,3.6a4,4,0,0,0,3.5.17l4.25-2.46a.72.72,0,0,0,.42-.56v-3.67L60.2,144.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.92,145.3v9.29a3.63,3.63,0,0,0,2-.39l4.25-2.45a1.17,1.17,0,0,0,.68-1v-4.06a.05.05,0,0,0,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.21,155.11h-.32l-.49,0v-10.4l8,1.54,0,.47v4.06a1.68,1.68,0,0,1-.94,1.44l-4.25,2.46A4.07,4.07,0,0,1,65.21,155.11Zm.22-9.19v8.16a2.88,2.88,0,0,0,1.26-.32l4.25-2.45c.19-.12.42-.3.42-.56v-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.19,147.6l-4.25,2.46a4.45,4.45,0,0,1-4-.17l-6.24-3.6c-1.19-.69-1.32-1.73-.29-2.32l4.25-2.45a4.45,4.45,0,0,1,4,.16l6.24,3.61C72.09,146,72.22,147,71.19,147.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.2,151a5.09,5.09,0,0,1-2.53-.64l-6.24-3.6A2.15,2.15,0,0,1,55.19,145a1.68,1.68,0,0,1,1-1.45l4.24-2.46a5,5,0,0,1,4.53.17l6.24,3.6a2.15,2.15,0,0,1,1.24,1.76,1.7,1.7,0,0,1-1,1.45L67.2,150.5A4,4,0,0,1,65.2,151Zm-2.81-9.34a3.05,3.05,0,0,0-1.48.33l-4.25,2.46c-.17.09-.44.29-.44.56s.27.6.73.86l6.24,3.61a4,4,0,0,0,3.5.16l4.25-2.45c.16-.09.43-.29.43-.56s-.27-.61-.72-.87l-6.24-3.6A4.17,4.17,0,0,0,62.39,141.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.21,139.43a1.13,1.13,0,0,0,0-.14,9.79,9.79,0,0,0-4.4-7.4l-.32-.17a7.14,7.14,0,0,0-1.1-.38,8.41,8.41,0,0,0-6.73,1.21.44.44,0,0,0-.12.59l8,13.21a.44.44,0,0,0,.63.13,9.63,9.63,0,0,0,3.71-5.22A8.87,8.87,0,0,0,71.21,139.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.94,147.07a.62.62,0,0,1-.19,0,1,1,0,0,1-.63-.44l-8-13.21a.94.94,0,0,1,.28-1.28,8.88,8.88,0,0,1,7.14-1.27,7.25,7.25,0,0,1,1.18.4,3.88,3.88,0,0,1,.37.2,10.33,10.33,0,0,1,4.65,7.79.73.73,0,0,1,0,.22h0a8.39,8.39,0,0,1-.35,2,10,10,0,0,1-3.88,5.43A.91.91,0,0,1,66.94,147.07ZM59,132.93,67,146a9.07,9.07,0,0,0,3.44-4.89,7.61,7.61,0,0,0,.3-1.71v-.1a9.27,9.27,0,0,0-4.14-7,3.1,3.1,0,0,1-.3-.16,7.35,7.35,0,0,0-1-.32A7.85,7.85,0,0,0,59,132.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.1,139.9l-2.3,1.5v.4l2.76,4.55a.44.44,0,0,0,.63.13,9.63,9.63,0,0,0,3.71-5.22,8.87,8.87,0,0,0,.31-1.83,1.13,1.13,0,0,0,0-.14,4.72,4.72,0,0,0-.39-1.54,19.22,19.22,0,0,1-2.72,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.94,147.07a.62.62,0,0,1-.19,0,1,1,0,0,1-.63-.44L63.28,142v-.83L66,139.35l2,.56a17.7,17.7,0,0,0,2.42-2.46l.6-.86.31,1,.15.45a3.5,3.5,0,0,1,.26,1.2.73.73,0,0,1,0,.22,8.23,8.23,0,0,1-.35,2,10,10,0,0,1-3.88,5.43A.91.91,0,0,1,66.94,147.07Zm-2.62-5.4L67,146a9.07,9.07,0,0,0,3.44-4.89,7.61,7.61,0,0,0,.3-1.71v-.1a2.34,2.34,0,0,0-.07-.52,27.84,27.84,0,0,1-2.2,2.08l-.21.17-2-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.8,131.89l-.32-.17a7.14,7.14,0,0,0-1.1-.38,8.38,8.38,0,0,0-6.6,1.13.57.57,0,0,0-.18.78l2.33,3.83a.11.11,0,0,0,.07.06l2,.75a.16.16,0,0,0,.17,0l1.1-1.45v0l.78-1.33,0,0c.2-.13,1.49-1,3-1.84a.14.14,0,0,0,0-.23A7.15,7.15,0,0,0,66.8,131.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.06,138.41a.59.59,0,0,1-.23,0l-2-.75a.66.66,0,0,1-.33-.27l-2.33-3.83A1.08,1.08,0,0,1,58.5,132a8.93,8.93,0,0,1,7-1.19,7.25,7.25,0,0,1,1.18.4l.37.19a8.08,8.08,0,0,1,1.44,1.11.63.63,0,0,1,.19.55.66.66,0,0,1-.32.5c-1.34.76-2.49,1.5-2.91,1.77l-.73,1.26-1.15,1.52A.65.65,0,0,1,63.06,138.41Zm-1.76-1.7,1.63.6.93-1.23.82-1.4.14-.11c.31-.21,1.34-.88,2.6-1.61a7.24,7.24,0,0,0-.87-.63h0a3.1,3.1,0,0,1-.3-.16,7.35,7.35,0,0,0-1-.32,7.89,7.89,0,0,0-6.23,1.05.07.07,0,0,0,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.46,143c0,1.91-.7,3.23-1.8,3.8s-3.67.11-5.22-.79a9.22,9.22,0,0,1-4.79-8.44c0-1.49.66-3.86,1.37-4.55,1-1,2.74-1.13,4.65,0A12.77,12.77,0,0,1,68.46,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.35,147.58a9.33,9.33,0,0,1-4.17-1.09,9.76,9.76,0,0,1-5-8.89c0-1.55.68-4.08,1.53-4.92,1.26-1.24,3.23-1.28,5.27-.11A13.39,13.39,0,0,1,69,143c0,2-.76,3.57-2.08,4.26A3.47,3.47,0,0,1,65.35,147.58Zm-5.26-14.84a2.35,2.35,0,0,0-1.71.67,8.17,8.17,0,0,0-1.22,4.19,8.67,8.67,0,0,0,4.54,8c1.51.88,3.94,1.18,4.72.78,1-.51,1.52-1.7,1.52-3.35a12.24,12.24,0,0,0-5.52-9.57A4.8,4.8,0,0,0,60.09,132.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.52,143.28c0,2.84-2,4-4.45,2.57a9.83,9.83,0,0,1-4.45-7.71c0-2.84,2-4,4.45-2.57A9.83,9.83,0,0,1,65.52,143.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.06,147a4.5,4.5,0,0,1-2.25-.68,10.42,10.42,0,0,1-4.7-8.15,3.21,3.21,0,0,1,5.22-3A10.45,10.45,0,0,1,66,143.28a3.63,3.63,0,0,1-1.56,3.33A2.88,2.88,0,0,1,63.06,147Zm-4-11.5a1.81,1.81,0,0,0-.91.23,2.65,2.65,0,0,0-1,2.44,9.29,9.29,0,0,0,4.2,7.27A2.22,2.22,0,0,0,65,143.28a9.29,9.29,0,0,0-4.2-7.27A3.52,3.52,0,0,0,59.09,135.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 60.45,
    y: 142.43,
    width: 2.25,
    height: 1.03,
    transform: "translate(-62.14 48.51) rotate(-29.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.25,
    y: 140.17,
    width: 3.74,
    height: 1.03,
    transform: "translate(-62.5 49.89) rotate(-30.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 59.4,
    y: 138.27,
    width: 1.78,
    height: 1.03,
    transform: "translate(-59.28 46.05) rotate(-28.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.31,155l0-.79a3.59,3.59,0,0,0,1.46-.34L70,152l.4.68-3.27,1.89A4.65,4.65,0,0,1,65.31,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.28,173.36l-11.63-2.26h0l-4.46.59s0,0,0,0v4.11a1.63,1.63,0,0,0,1,1.31l6.24,3.6a4.45,4.45,0,0,0,4,.16l4.25-2.45a1.17,1.17,0,0,0,.68-1V173.4S118.3,173.36,118.28,173.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.62,181.83a5.19,5.19,0,0,1-2.52-.64l-6.24-3.6a2.16,2.16,0,0,1-1.23-1.74v-4.56l.48-.1,4.58-.61.13,0,12,2.31,0,.47v4.06a1.7,1.7,0,0,1-.94,1.45l-4.25,2.45A4.15,4.15,0,0,1,111.62,181.83Zm-9-9.68v3.69c0,.28.27.6.71.86l6.24,3.6a4,4,0,0,0,3.5.17l4.25-2.45a.71.71,0,0,0,.43-.56v-3.68l-11.18-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.34,172v9.29a3.74,3.74,0,0,0,2-.39l4.25-2.45a1.19,1.19,0,0,0,.68-1V173.4s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.64,181.83h-.33l-.48,0V171.4l8,1.54,0,.46v4.07a1.7,1.7,0,0,1-.94,1.44l-4.25,2.45A4,4,0,0,1,111.64,181.83Zm.22-9.19v8.16a2.84,2.84,0,0,0,1.25-.33l4.25-2.45a.71.71,0,0,0,.43-.56v-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.62,174.32l-4.25,2.45a4.45,4.45,0,0,1-4-.16L103.12,173c-1.19-.68-1.32-1.72-.29-2.31l4.25-2.46a4.45,4.45,0,0,1,4,.17l6.24,3.6C118.52,172.69,118.65,173.72,117.62,174.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.62,177.69a5.19,5.19,0,0,1-2.52-.64l-6.24-3.6a2.15,2.15,0,0,1-1.24-1.76,1.7,1.7,0,0,1,.95-1.45l4.25-2.45a5,5,0,0,1,4.53.16l6.24,3.61a2.13,2.13,0,0,1,1.24,1.75,1.69,1.69,0,0,1-1,1.45l-4.25,2.46A4.15,4.15,0,0,1,111.62,177.69Zm-2.8-9.35a3,3,0,0,0-1.49.34l-4.24,2.45c-.17.09-.44.29-.44.56s.27.61.72.87l6.24,3.6a4,4,0,0,0,3.5.17l4.25-2.46c.17-.09.44-.29.44-.56s-.27-.6-.72-.86l-6.25-3.61A4.1,4.1,0,0,0,108.82,168.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.64,166.15a1.42,1.42,0,0,0,0-.15,9.81,9.81,0,0,0-4.4-7.4l-.32-.17a8.6,8.6,0,0,0-1.11-.37,8.36,8.36,0,0,0-6.72,1.21.43.43,0,0,0-.12.58l8,13.21a.44.44,0,0,0,.63.13,9.6,9.6,0,0,0,3.71-5.22A8.91,8.91,0,0,0,117.64,166.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.37,173.79l-.19,0a1,1,0,0,1-.63-.44l-8-13.21a.94.94,0,0,1,.27-1.28,8.9,8.9,0,0,1,7.15-1.28,8.33,8.33,0,0,1,1.19.41l.36.19a10.35,10.35,0,0,1,4.65,7.82h0s0,.1,0,.2h0a8.54,8.54,0,0,1-.35,2,10.12,10.12,0,0,1-3.88,5.43A1,1,0,0,1,113.37,173.79Zm-7.94-14.14,8,13.08a9.13,9.13,0,0,0,3.44-4.9,8,8,0,0,0,.3-1.7v0a9.25,9.25,0,0,0-4.15-7c-.09-.06-.29-.16-.29-.16a9,9,0,0,0-1-.33A7.88,7.88,0,0,0,105.43,159.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.52,166.62l-2.29,1.49v.41l2.77,4.54a.44.44,0,0,0,.63.13,9.6,9.6,0,0,0,3.71-5.22,8.91,8.91,0,0,0,.31-1.82,1.42,1.42,0,0,0,0-.15,4.72,4.72,0,0,0-.39-1.54,19.37,19.37,0,0,1-2.73,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.37,173.79l-.19,0a1,1,0,0,1-.63-.44l-2.84-4.67v-.83l2.73-1.77,2,.56a17.6,17.6,0,0,0,2.43-2.45l.6-.86.31,1,.15.44a3.63,3.63,0,0,1,.26,1.23h0s0,.1,0,.2a8.66,8.66,0,0,1-.35,2,10.12,10.12,0,0,1-3.88,5.43A1,1,0,0,1,113.37,173.79Zm-2.62-5.4,2.64,4.34a9.13,9.13,0,0,0,3.44-4.9,8.14,8.14,0,0,0,.3-1.7l0-.11a2.3,2.3,0,0,0-.06-.51,24.71,24.71,0,0,1-2.21,2.07l-.21.18-2-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.23,158.6l-.32-.17a8.6,8.6,0,0,0-1.11-.37,8.36,8.36,0,0,0-6.6,1.12.58.58,0,0,0-.17.79l2.32,3.83a.24.24,0,0,0,.08.06l2,.74a.14.14,0,0,0,.17,0l1.1-1.46h0l.78-1.33,0,0c.2-.13,1.5-1,3-1.84a.16.16,0,0,0,0-.24A7.15,7.15,0,0,0,113.23,158.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.48,165.13a.64.64,0,0,1-.23,0l-2-.74a.65.65,0,0,1-.33-.28l-2.33-3.82a1.09,1.09,0,0,1,.34-1.49,8.92,8.92,0,0,1,7-1.19,8.33,8.33,0,0,1,1.19.41l.36.19h0a7.56,7.56,0,0,1,1.44,1.1.68.68,0,0,1,.19.56.65.65,0,0,1-.33.49c-1.39.8-2.6,1.58-2.9,1.78l-.74,1.25L110,164.87A.7.7,0,0,1,109.48,165.13Zm-1.75-1.71,1.62.61.94-1.24.82-1.4.14-.11s1.18-.78,2.6-1.61a6.16,6.16,0,0,0-.87-.62h0l-.3-.16a9,9,0,0,0-1-.33,7.91,7.91,0,0,0-6.23,1.06s0,0,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.88,169.75c0,1.9-.69,3.22-1.8,3.8s-3.67.1-5.21-.79a9.23,9.23,0,0,1-4.8-8.45c0-1.48.67-3.85,1.38-4.55,1-1,2.74-1.13,4.65,0A12.8,12.8,0,0,1,114.88,169.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.78,174.3a9.14,9.14,0,0,1-4.17-1.1,9.75,9.75,0,0,1-5-8.89c0-1.54.68-4.08,1.53-4.91,1.26-1.25,3.23-1.29,5.27-.11a13.36,13.36,0,0,1,6,10.46c0,2-.76,3.57-2.08,4.25A3.33,3.33,0,0,1,111.78,174.3Zm-5.26-14.85a2.35,2.35,0,0,0-1.71.68,8.16,8.16,0,0,0-1.22,4.18,8.67,8.67,0,0,0,4.54,8c1.51.87,3.94,1.18,4.72.77,1-.51,1.52-1.7,1.52-3.34a12.22,12.22,0,0,0-5.53-9.57A4.65,4.65,0,0,0,106.52,159.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112,170c0,2.84-2,4-4.45,2.57a9.83,9.83,0,0,1-4.45-7.71c0-2.84,2-4,4.45-2.57A9.83,9.83,0,0,1,112,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.49,173.69a4.58,4.58,0,0,1-2.25-.68,10.45,10.45,0,0,1-4.71-8.16,3.22,3.22,0,0,1,5.23-3,10.43,10.43,0,0,1,4.7,8.15,3.6,3.6,0,0,1-1.56,3.33A2.73,2.73,0,0,1,109.49,173.69Zm-4-11.5a1.79,1.79,0,0,0-.9.22,2.65,2.65,0,0,0-1,2.44,9.26,9.26,0,0,0,4.2,7.27,2.22,2.22,0,0,0,3.68-2.13,9.25,9.25,0,0,0-4.2-7.26A3.52,3.52,0,0,0,105.51,162.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 106.88,
    y: 169.15,
    width: 2.25,
    height: 1.03,
    transform: "translate(-69.28 74.68) rotate(-29.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.68,
    y: 166.88,
    width: 3.74,
    height: 1.03,
    transform: "translate(-69.65 76.9) rotate(-30.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.83,
    y: 164.98,
    width: 1.78,
    height: 1.03,
    transform: "translate(-66.27 71.41) rotate(-28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.74,181.71l0-.79a3.87,3.87,0,0,0,1.45-.34l3.27-1.89.39.68-3.26,1.89A4.55,4.55,0,0,1,111.74,181.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.88,
    y: 248.1,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.75 112.8) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.49,
    y: 248.96,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103 113.78) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.96,
    y: 249.87,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.23 114.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 136.6,
    y: 250.72,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.43 115.51) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 137.96,
    y: 251.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.73 116.34) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.57,
    y: 252.52,
    width: 55.03,
    height: 0.59,
    transform: "translate(-103.93 117.23) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 141.03,
    y: 253.44,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.2 118.09) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 142.68,
    y: 254.28,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.4 119.02) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 144.14,
    y: 255.19,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.68 119.91) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 145.78,
    y: 256.05,
    width: 55.03,
    height: 0.59,
    transform: "translate(-104.87 120.81) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.24,
    y: 256.97,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.15 121.7) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 148.89,
    y: 257.81,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.35 122.63) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.24,
    y: 258.75,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.64 123.44) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 151.86,
    y: 259.61,
    width: 55.03,
    height: 0.59,
    transform: "translate(-105.83 124.32) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 153.32,
    y: 260.53,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.13 125.24) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 154.96,
    y: 261.37,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.32 126.15) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.43,
    y: 262.29,
    width: 55.03,
    height: 0.59,
    transform: "translate(-106.56 126.96) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 110.33,
    y: 235.73,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.49 100.44) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.97,
    y: 236.58,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.68 101.35) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 113.33,
    y: 237.52,
    width: 55.03,
    height: 0.59,
    transform: "translate(-99.97 102.16) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.94,
    y: 238.38,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.17 103.06) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.4,
    y: 239.3,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.42 103.9) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118.05,
    y: 240.14,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.65 104.87) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.51,
    y: 241.05,
    width: 55.03,
    height: 0.59,
    transform: "translate(-100.89 105.68) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.15,
    y: 241.91,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.13 106.67) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.61,
    y: 242.83,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.36 107.47) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.26,
    y: 243.67,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.59 108.46) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.61,
    y: 244.61,
    width: 55.03,
    height: 0.59,
    transform: "translate(-101.86 109.23) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.23,
    y: 245.47,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.08 110.16) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 128.69,
    y: 246.39,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.33 110.98) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.33,
    y: 247.23,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.53 111.91) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.8,
    y: 248.15,
    width: 55.03,
    height: 0.59,
    transform: "translate(-102.82 112.83) rotate(-29.98)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.86,245.53h-1.2l-17.32-10a3.88,3.88,0,0,0-3.5-.14l-17.43,10.06h0l-1.29.07a.09.09,0,0,0-.09.09v1.12h0c0,.41.25.85.85,1.2l17.75,10.25a3.91,3.91,0,0,0,3.5.14l18.25-10.54a1,1,0,0,0,.59-.81v-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.56,259.19a4.58,4.58,0,0,1-2.23-.56l-17.75-10.25a2,2,0,0,1-1.09-1.37h0v-1.39a.6.6,0,0,1,.57-.6l1.2-.06,17.34-10a4.41,4.41,0,0,1,4,.15L171.81,245h1.49l.16,1.1V247a1.6,1.6,0,0,1-.85,1.25l-18.26,10.53A3.6,3.6,0,0,1,152.56,259.19ZM132.5,246.47h0v.29c0,.23.21.5.59.72l17.75,10.25a3.37,3.37,0,0,0,3,.15l18.25-10.54c.15-.09.33-.23.34-.41v-.79l0-.1h-.83l-.16-.08-17.34-10a3.37,3.37,0,0,0-3-.15L133.56,246l-.17,0-.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.34,246.47,154.09,257a3.88,3.88,0,0,1-3.5-.15l-17.75-10.24c-1-.6-1.15-1.51-.26-2l18.26-10.53a3.88,3.88,0,0,1,3.5.14l17.75,10.25C173.13,245.05,173.24,246,172.34,246.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.56,257.87a4.58,4.58,0,0,1-2.23-.56l-17.75-10.25a1.93,1.93,0,0,1-1.11-1.59,1.5,1.5,0,0,1,.86-1.32l18.25-10.54a4.38,4.38,0,0,1,4,.15L172.35,244a2,2,0,0,1,1.11,1.59,1.54,1.54,0,0,1-.86,1.32l-18.26,10.54A3.6,3.6,0,0,1,152.56,257.87Zm-.21-23.65a2.58,2.58,0,0,0-1.26.28L132.84,245c-.13.07-.35.23-.35.43s.16.45.6.7l17.75,10.25a3.37,3.37,0,0,0,3,.14L172.08,246c.13-.08.35-.24.35-.44s-.15-.44-.6-.7l-17.75-10.25A3.6,3.6,0,0,0,152.35,234.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 152.07,
    y: 257.49,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 133.16,
    y: 247.2,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 135.68,
    y: 248.54,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 171.01,
    y: 247.08,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.12,242.47l-.05-.22-7.69-28.94h-9.81l-7.75,29.16,0,.11c-.72,2.41.49,4.87,3.58,6.73,5,3,13.17,3,18.19,0C164.66,247.45,165.84,244.88,165.12,242.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.48,252.07a18.64,18.64,0,0,1-9.36-2.32c-3.24-1.95-4.62-4.61-3.81-7.31v-.08l7.86-29.56h10.6l7.84,29.54c.81,2.73-.6,5.5-3.79,7.41A18.63,18.63,0,0,1,152.48,252.07ZM148,213.83,140.3,242.7c-.68,2.25.55,4.49,3.35,6.17,4.86,2.92,12.79,2.92,17.65,0,2.76-1.66,4-4,3.33-6.25l-.06-.25L157,213.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.94,211.23c1.92,1.15,1.92,3,0,4.17a7.39,7.39,0,0,1-6.93,0c-1.92-1.15-1.92-3,0-4.17A7.39,7.39,0,0,1,155.94,211.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.48,216.78a7.37,7.37,0,0,1-3.74-.94,2.74,2.74,0,0,1,0-5.05,7.91,7.91,0,0,1,7.47,0h0a2.74,2.74,0,0,1,0,5.05A7.36,7.36,0,0,1,152.48,216.78Zm0-5.9a6.39,6.39,0,0,0-3.21.79,1.73,1.73,0,0,0,0,3.29,6.86,6.86,0,0,0,6.41,0,1.73,1.73,0,0,0,0-3.29A6.33,6.33,0,0,0,152.48,210.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.65,212.24a5.82,5.82,0,0,0-4.38,0c-1.21.56-1.21,1.48,0,2a5.82,5.82,0,0,0,4.38,0C155.87,213.72,155.87,212.8,154.65,212.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.46,215.22a6,6,0,0,1-2.41-.47c-1.05-.49-1.2-1.15-1.2-1.49s.15-1,1.2-1.49a6.38,6.38,0,0,1,4.82,0c1,.49,1.21,1.14,1.21,1.49s-.16,1-1.21,1.49A5.92,5.92,0,0,1,152.46,215.22Zm0-2.89a4.81,4.81,0,0,0-2,.37c-.43.2-.62.42-.62.56s.19.36.62.56a5.39,5.39,0,0,0,3.95,0c.42-.2.61-.42.61-.56s-.19-.36-.61-.56h0A4.89,4.89,0,0,0,152.46,212.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.89,226.53l-1.64-6.14h0c.27,1.22-.37,2.5-1.94,3.44a10.34,10.34,0,0,1-9.67,0c-1.56-.94-2.21-2.22-1.94-3.44h0l-1.15,4.35-.53,2c-.45,1.59.34,3.29,2.39,4.53a13,13,0,0,0,12.17,0C160.74,230,161.47,228.22,160.89,226.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.5,233.31a12.59,12.59,0,0,1-6.35-1.57c-2.18-1.31-3.16-3.22-2.62-5.12l1.77-6.75h1l-.13.63c-.24,1.05.38,2.1,1.69,2.89a9.81,9.81,0,0,0,9.15,0c1.31-.79,1.93-1.84,1.7-2.89l-.14-.63h1l.11.38,1.63,6.13c.67,2-.27,4-2.53,5.36A12.64,12.64,0,0,1,152.5,233.31Zm-6.86-10.68-1.12,4.26c-.42,1.46.37,2.89,2.16,4a12.48,12.48,0,0,0,11.64,0c1.85-1.12,2.61-2.63,2.09-4.17v0l-1.08-4a5,5,0,0,1-1.74,1.65,10.89,10.89,0,0,1-10.2,0A5,5,0,0,1,145.64,222.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.32,239.45h0l-.09-.33,0-.05-1.52-5.61h0c.35,1.82-.62,3.71-2.94,5.11a15.57,15.57,0,0,1-14.59,0c-2.33-1.4-3.3-3.29-2.94-5.11h0l-1.57,6h0c-.5,2.15.61,4.42,3.37,6.08,4.67,2.8,12.24,2.8,16.91,0C163.71,243.87,164.82,241.6,164.32,239.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.49,248.13a17.3,17.3,0,0,1-8.72-2.16c-2.59-1.56-3.94-3.77-3.71-6H140l.15-.64,1.67-6.38h1l-.11.62c-.33,1.67.66,3.34,2.7,4.57a15.07,15.07,0,0,0,14.06,0c2-1.23,3-2.9,2.7-4.57l-.12-.62h1l.11.38L165,240h-.07c.23,2.24-1.12,4.45-3.71,6A17.33,17.33,0,0,1,152.49,248.13Zm-11.27-8.84-.06.27c-.47,2,.67,4.05,3.14,5.53,4.51,2.71,11.86,2.71,16.38,0,2.47-1.48,3.61-3.5,3.14-5.53l-.08-.31-.87-3.2a6.92,6.92,0,0,1-2.85,3,16.18,16.18,0,0,1-15.12,0,7,7,0,0,1-2.84-2.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 134.49,
    y: 229.45,
    width: 23.95,
    height: 1.03,
    transform: "translate(-109.6 323.6) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.23,
    y: 225.49,
    width: 2.21,
    height: 1.03,
    transform: "translate(-105.05 321.34) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.94,
    y: 239.95,
    width: 2.44,
    height: 1.03,
    transform: "translate(-121.66 329.59) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.34,212.25c-1.15.53-1.15,1.39,0,1.93a4.13,4.13,0,0,0,.86.27l.31-2.53A4.1,4.1,0,0,0,150.34,212.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.64,215.07l-.55-.12a4.61,4.61,0,0,1-1-.31c-1-.47-1.15-1.09-1.15-1.43s.15-1,1.15-1.43h0a4.85,4.85,0,0,1,1.31-.37l.67-.1Zm-.73-2.49a2.34,2.34,0,0,0-.35.13h0c-.45.21-.57.41-.57.5s.12.3.57.5l.2.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 157.56,
    y: 221.37,
    width: 1.03,
    height: 6.24,
    transform: "translate(-45.9 40.7) rotate(-12.83)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.71,
    y: 232.23,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.84 133.07) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 178.32,
    y: 233.09,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.07 134.03) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 179.78,
    y: 234.01,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.32 134.87) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 181.42,
    y: 234.85,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.52 135.8) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 182.78,
    y: 235.79,
    width: 55.03,
    height: 0.59,
    transform: "translate(-89.8 136.57) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 184.39,
    y: 236.65,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.03 137.54) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.86,
    y: 237.57,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.28 138.35) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.5,
    y: 238.41,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.48 139.29) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 188.96,
    y: 239.33,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.76 140.18) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 190.6,
    y: 240.19,
    width: 55.03,
    height: 0.59,
    transform: "translate(-90.95 141.07) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 192.07,
    y: 241.1,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.23 141.97) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 193.71,
    y: 241.94,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.42 142.89) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 195.07,
    y: 242.89,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.73 143.73) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 196.68,
    y: 243.75,
    width: 55.03,
    height: 0.59,
    transform: "translate(-91.92 144.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 198.14,
    y: 244.66,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.2 145.48) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 199.79,
    y: 245.51,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.38 146.36) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 201.25,
    y: 246.42,
    width: 55.03,
    height: 0.59,
    transform: "translate(-92.64 147.22) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.15,
    y: 219.87,
    width: 55.03,
    height: 0.59,
    transform: "translate(-85.56 120.69) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 156.8,
    y: 220.71,
    width: 55.03,
    height: 0.59,
    transform: "translate(-85.74 121.58) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 158.15,
    y: 221.65,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.05 122.43) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.76,
    y: 222.51,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.25 123.31) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 161.23,
    y: 223.43,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.52 124.18) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 162.87,
    y: 224.27,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.73 125.14) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 164.33,
    y: 225.19,
    width: 55.03,
    height: 0.59,
    transform: "translate(-86.97 125.95) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 165.97,
    y: 226.05,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.2 126.92) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 167.44,
    y: 226.96,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.45 127.76) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 169.08,
    y: 227.8,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.66 128.71) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 170.44,
    y: 228.75,
    width: 55.03,
    height: 0.59,
    transform: "translate(-87.94 129.47) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 172.05,
    y: 229.61,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.16 130.43) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 173.51,
    y: 230.52,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.41 131.25) rotate(-29.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 175.16,
    y: 231.37,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.62 132.2) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.62,
    y: 232.28,
    width: 55.03,
    height: 0.59,
    transform: "translate(-88.89 133.07) rotate(-29.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.68,229.67h-1.15l-.05,0-17.32-10a3.88,3.88,0,0,0-3.5-.15l-17.43,10.06,0,0-1.3.06a.1.1,0,0,0-.08.1v1.12h0a1.38,1.38,0,0,0,.85,1.2l17.75,10.25a3.91,3.91,0,0,0,3.5.15l18.25-10.54a1.08,1.08,0,0,0,.6-.81v-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.39,243.33a4.52,4.52,0,0,1-2.24-.57L177.4,232.52a2,2,0,0,1-1.08-1.38h0v-1.38a.61.61,0,0,1,.58-.61l1.19-.06,17.34-10a4.41,4.41,0,0,1,4,.14l17.22,9.94h1.48l.16,1.1v.87a1.57,1.57,0,0,1-.85,1.25l-18.25,10.54A3.63,3.63,0,0,1,197.39,243.33ZM177.32,230.6l0,0v.29c0,.22.21.5.59.72l17.75,10.25a3.4,3.4,0,0,0,3,.14l18.25-10.54a.61.61,0,0,0,.34-.41v-.89h-.85l-.17-.08-17.31-10a3.37,3.37,0,0,0-3-.14l-17.54,10.12-.16,0-.9.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.16,230.61l-18.25,10.53a3.88,3.88,0,0,1-3.5-.14l-17.75-10.25c-1-.6-1.15-1.5-.25-2l18.25-10.54a3.88,3.88,0,0,1,3.5.15l17.75,10.24C218,229.18,218.06,230.09,217.16,230.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.39,242a4.52,4.52,0,0,1-2.24-.57L177.4,231.19a1.92,1.92,0,0,1-1.11-1.58,1.55,1.55,0,0,1,.86-1.33l18.25-10.53a4.41,4.41,0,0,1,4,.14l17.75,10.25a1.93,1.93,0,0,1,1.11,1.59,1.52,1.52,0,0,1-.86,1.32l-18.25,10.54A3.63,3.63,0,0,1,197.39,242Zm-.21-23.66a2.58,2.58,0,0,0-1.26.28l-18.26,10.54c-.13.08-.35.23-.35.44s.16.44.61.7l17.75,10.24a3.37,3.37,0,0,0,3,.15l18.25-10.54c.13-.07.35-.23.35-.43s-.16-.45-.6-.7l-17.75-10.25A3.61,3.61,0,0,0,197.18,218.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 196.89,
    y: 241.63,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.99,
    y: 231.33,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 180.5,
    y: 232.67,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 215.84,
    y: 231.21,
    width: 0.79,
    height: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210,226.61l-.06-.23-7.69-28.93h-9.8l-7.75,29.16,0,.11c-.72,2.4.49,4.86,3.59,6.72,5,3,13.16,3,18.18,0C209.49,231.58,210.67,229,210,226.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.3,236.2a18.54,18.54,0,0,1-9.36-2.32c-3.23-1.94-4.62-4.61-3.81-7.31l0-.08L192,196.94h10.6l7.84,29.53c.81,2.73-.6,5.5-3.78,7.41A18.54,18.54,0,0,1,197.3,236.2ZM192.79,198l-7.67,28.88c-.67,2.24.55,4.48,3.35,6.16,4.87,2.92,12.79,2.92,17.66,0,2.76-1.66,4-4,3.33-6.24l-.07-.26L201.81,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.77,195.37c1.91,1.15,1.91,3,0,4.16a7.41,7.41,0,0,1-6.94,0c-1.91-1.15-1.91-3,0-4.16A7.41,7.41,0,0,1,200.77,195.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.3,200.91a7.33,7.33,0,0,1-3.73-.94,2.72,2.72,0,0,1,0-5,7.83,7.83,0,0,1,7.46,0h0a2.72,2.72,0,0,1,0,5A7.33,7.33,0,0,1,197.3,200.91Zm0-5.9a6.33,6.33,0,0,0-3.2.8,1.73,1.73,0,0,0,0,3.28,6.84,6.84,0,0,0,6.4,0,1.73,1.73,0,0,0,0-3.28A6.33,6.33,0,0,0,197.3,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.48,196.37a6,6,0,0,0-4.39,0c-1.21.57-1.21,1.48,0,2a6,6,0,0,0,4.39,0C200.69,197.85,200.69,196.94,199.48,196.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.29,199.35a5.76,5.76,0,0,1-2.41-.47c-1-.49-1.21-1.14-1.21-1.49s.16-1,1.21-1.48a6.38,6.38,0,0,1,4.82,0h0c1,.49,1.2,1.14,1.2,1.48s-.16,1-1.2,1.49A5.82,5.82,0,0,1,197.29,199.35Zm0-2.89a4.89,4.89,0,0,0-2,.38c-.42.19-.61.42-.61.55s.19.36.61.56a5.39,5.39,0,0,0,3.95,0c.42-.2.61-.42.61-.56s-.19-.36-.61-.55A4.81,4.81,0,0,0,197.29,196.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.72,210.66l-1.64-6.14h0c.27,1.22-.37,2.51-1.93,3.45a10.36,10.36,0,0,1-9.68,0c-1.56-.94-2.2-2.23-1.93-3.45h0l-1.14,4.35-.53,2c-.46,1.6.33,3.3,2.38,4.53a13,13,0,0,0,12.17,0C205.56,214.14,206.29,212.36,205.72,210.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.32,217.45a12.6,12.6,0,0,1-6.35-1.58c-2.18-1.31-3.16-3.22-2.62-5.11l1.78-6.75h1l-.13.62c-.23,1.05.39,2.11,1.7,2.9a9.79,9.79,0,0,0,9.14,0c1.31-.79,1.93-1.85,1.7-2.9l-.14-.62h1l.1.38,1.64,6.12c.67,2-.28,4-2.54,5.36A12.6,12.6,0,0,1,197.32,217.45Zm-6.86-10.69L189.34,211c-.41,1.45.38,2.89,2.16,4a12.42,12.42,0,0,0,11.64,0c1.85-1.11,2.61-2.63,2.09-4.16v0l-1.08-4a5.14,5.14,0,0,1-1.74,1.65,11,11,0,0,1-10.2,0A5.14,5.14,0,0,1,190.46,206.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.14,223.58h0l-.09-.33v0l-1.52-5.62h0c.36,1.82-.62,3.72-2.94,5.11a15.57,15.57,0,0,1-14.59,0c-2.32-1.39-3.3-3.29-2.94-5.11h0l-1.57,6h0c-.51,2.16.61,4.42,3.37,6.08,4.67,2.81,12.24,2.81,16.91,0C208.53,228,209.65,225.74,209.14,223.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.31,232.27a17.26,17.26,0,0,1-8.72-2.17c-2.59-1.55-3.94-3.76-3.71-6h-.06l.16-.64,1.67-6.37h1l-.12.61c-.33,1.68.66,3.34,2.71,4.57a15,15,0,0,0,14.06,0c2-1.23,3-2.89,2.7-4.57l-.12-.61h1l.11.38,1.8,6.63h-.08c.23,2.25-1.12,4.46-3.71,6A17.2,17.2,0,0,1,197.31,232.27ZM186,223.43l0,.27c-.48,2,.66,4,3.13,5.52,4.52,2.72,11.87,2.72,16.38,0,2.47-1.48,3.62-3.49,3.14-5.52l-.07-.31-.87-3.2a7,7,0,0,1-2.86,2.95,16.16,16.16,0,0,1-15.11,0,7,7,0,0,1-2.84-2.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 179.31,
    y: 213.58,
    width: 23.95,
    height: 1.03,
    transform: "translate(-58.91 354.92) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 191.05,
    y: 209.63,
    width: 2.21,
    height: 1.03,
    transform: "translate(-54.36 352.66) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 187.76,
    y: 224.09,
    width: 2.44,
    height: 1.03,
    transform: "translate(-70.98 360.91) rotate(-77.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.16,196.38c-1.14.53-1.14,1.4,0,1.93a3.76,3.76,0,0,0,.86.27l.31-2.53A4.45,4.45,0,0,0,195.16,196.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.46,199.2l-.55-.11a4.93,4.93,0,0,1-1-.31c-1-.47-1.16-1.1-1.16-1.43s.15-1,1.15-1.43h0a4.52,4.52,0,0,1,1.31-.37l.67-.1Zm-.73-2.49a2.83,2.83,0,0,0-.35.14h0c-.44.2-.56.41-.56.5s.12.29.56.5l.2.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.22,
    y: 217.13,
    width: 1.03,
    height: 8.77,
    transform: "translate(-43.05 49.76) rotate(-12.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 202.21,
    y: 205.53,
    width: 1.03,
    height: 4.84,
    transform: "translate(-40.17 48.76) rotate(-12.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.49,18.18,128,4.62a3.64,3.64,0,0,0-3.46-.42l-.92.56-6.76,4.17a.08.08,0,0,0,0,.1c.35.72,3.53,7.39,3.82,8.62.13.52,1.13,5.62,2.28,11.56h0v3a10.43,10.43,0,0,0,1.58,5.15s0,0,0,0c1.2,6.19,2.22,11.48,2.25,11.62h0l3.48,8.22a.08.08,0,0,0,.12,0l7.95-4.64a.07.07,0,0,0,0-.1l-.59-1.68h0a18.87,18.87,0,0,1-.33-2.59l10.14,11.28a.08.08,0,0,0,.11,0L155.09,55l.11-.07h0a3.61,3.61,0,0,0,1.41-3.24V27.06A11.36,11.36,0,0,0,151.49,18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.64,60.15a.68.68,0,0,1-.5-.22L138.21,50c0,.24.08.49.13.73l.57,1.61a.67.67,0,0,1-.3.81l-8.19,4.77-.32-.08a.7.7,0,0,1-.41-.38l-3.53-8.39-2.22-11.49a10.87,10.87,0,0,1-1.62-5.38V29.26c-1.36-7-2.16-11-2.26-11.47-.23-1-2.57-6-3.78-8.5a.66.66,0,0,1,.26-.86l7.68-4.73a4.21,4.21,0,0,1,4.07.41l23.5,13.56a12,12,0,0,1,5.42,9.39v24.6a4.2,4.2,0,0,1-1.69,3.74l-.14.08L148,60.05A.64.64,0,0,1,147.64,60.15ZM136.75,46.6l11,12.22,7.05-4.36.39.46-.32-.5A3.08,3.08,0,0,0,156,51.66V27.06a10.86,10.86,0,0,0-4.82-8.36L127.7,5.13a3.11,3.11,0,0,0-2.9-.4L117.55,9.2c.88,1.84,3.39,7.15,3.66,8.31.14.59,1.32,6.62,2.28,11.59l0,.12v3A9.9,9.9,0,0,0,125,37.05l0,.1,0,.13,2.24,11.56,3.24,7.63,7.09-4.14L137.18,51a19.51,19.51,0,0,1-.34-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.47,18.18l-22-12.66-11.08,7L142,24.88l5,.78,7.62-4.53A9.92,9.92,0,0,0,151.47,18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147,26.28l-5.35-.88L117.18,12.51l12.25-7.68,22.33,12.84A10.51,10.51,0,0,1,155,20.79l.36.53Zm-4.88-2,4.64.73L153.66,21a8.7,8.7,0,0,0-2.49-2.26L129.46,6.21l-9.9,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.81,29.7s-9.52,2.25-10.13,2.48a122.75,122.75,0,0,0-13,11.23c.63,3.25,1.06,5.5,1.08,5.59h0l3.48,8.22a.08.08,0,0,0,.12,0l7.95-4.64a.07.07,0,0,0,0-.1l-.59-1.68h0a18.87,18.87,0,0,1-.33-2.59l10.14,11.28a.08.08,0,0,0,.11,0L155.09,55l.11-.07h0a3.61,3.61,0,0,0,1.41-3.24V27.06a8.65,8.65,0,0,0-.22-1.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 149.75,
    y: 30.45,
    width: 6.58,
    height: 0.79,
    transform: "matrix(0.86, -0.52, 0.52, 0.86, 6.13, 83.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 149.57,
    y: 52.51,
    width: 6.58,
    height: 0.79,
    transform: "translate(-5.31 86.77) rotate(-31.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144,22.87,120.44,9.28c-2.81-1.62-5.08-.3-5.08,2.94V36.87a11.22,11.22,0,0,0,5.08,8.8l2.68,1.54a2.22,2.22,0,0,1,1,1.52,13.33,13.33,0,0,0,5.17,8.55c.74.55,1.33.08,1.11-.87a20.37,20.37,0,0,1-.54-4.14c0-.65.46-.9,1-.58L144,59.26c2.81,1.62,5.08.3,5.08-2.94V31.67A11.22,11.22,0,0,0,144,22.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.25,60.55a5.2,5.2,0,0,1-2.57-.78L130.57,52.2l-.13-.06a.45.45,0,0,1,0,.12,19.17,19.17,0,0,0,.53,4,1.47,1.47,0,0,1-.49,1.66,1.34,1.34,0,0,1-1.55-.17,13.84,13.84,0,0,1-5.4-8.94,1.73,1.73,0,0,0-.7-1.09l-2.69-1.55a11.9,11.9,0,0,1-5.37-9.31V12.22a4.14,4.14,0,0,1,1.78-3.81,4.16,4.16,0,0,1,4.19.36l23.54,13.59a11.9,11.9,0,0,1,5.37,9.31V56.32a4.14,4.14,0,0,1-1.78,3.81A3.21,3.21,0,0,1,146.25,60.55ZM130.41,51a1.53,1.53,0,0,1,.76.22l13.11,7.57a2.53,2.53,0,0,0,4.19-2.43V31.67a10.58,10.58,0,0,0-4.79-8.28L120.14,9.8a3,3,0,0,0-3-.36A3,3,0,0,0,116,12.22V36.87a10.58,10.58,0,0,0,4.79,8.28l2.68,1.55a2.86,2.86,0,0,1,1.28,1.93,12.66,12.66,0,0,0,4.93,8.18.47.47,0,0,0,.24.11s0-.13-.05-.38a19.14,19.14,0,0,1-.56-4.27,1.26,1.26,0,0,1,.58-1.16A1.16,1.16,0,0,1,130.41,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.81,21.86c-5.93-3.43-10.75-.64-10.75,6.2s4.82,15.2,10.75,18.62,10.75.64,10.75-6.2S137.74,25.28,131.81,21.86Zm-8.15,7.71c0-5.19,3.66-7.3,8.15-4.71a15.49,15.49,0,0,1,4.56,4.25l-11,7.27A15.94,15.94,0,0,1,123.66,29.57Zm8.15,14.11a15.54,15.54,0,0,1-4.49-4.15l10.94-7.27A15.91,15.91,0,0,1,140,39C140,44.16,136.3,46.27,131.81,43.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.6,48.55a10.17,10.17,0,0,1-5-1.52c-6-3.49-10.94-12-10.94-19,0-3.45,1.19-6,3.35-7.29s5-1,8,.75h0c6,3.48,11,12,11,19,0,3.45-1.19,6.05-3.35,7.29A5.92,5.92,0,0,1,136.6,48.55ZM127,20.78a5.2,5.2,0,0,0-2.61.67c-1.91,1.1-3,3.45-3,6.61,0,6.72,4.73,14.92,10.55,18.28,2.74,1.58,5.3,1.85,7.2.75s3-3.45,3-6.61c0-6.72-4.74-14.92-10.56-18.28h0A9.34,9.34,0,0,0,127,20.78Zm8.42,24.41A7.77,7.77,0,0,1,131.61,44h0a15.78,15.78,0,0,1-4.6-4.26l-.25-.33,11.66-7.75.19.41A16.13,16.13,0,0,1,140.35,39c0,2.65-.91,4.64-2.58,5.61A4.62,4.62,0,0,1,135.44,45.19Zm-7.55-5.57A14.81,14.81,0,0,0,132,43.34h0c2,1.18,4,1.38,5.36.56s2.2-2.56,2.2-4.92a15.15,15.15,0,0,0-1.47-6.14ZM125.26,37l-.2-.4a16.25,16.25,0,0,1-1.79-7c0-2.66.92-4.65,2.58-5.62s3.86-.76,6.16.57a15.76,15.76,0,0,1,4.68,4.35l.24.34Zm2.92-12.82a3.8,3.8,0,0,0-1.93.5c-1.41.81-2.19,2.56-2.19,4.93a15.18,15.18,0,0,0,1.51,6.23L135.8,29a14.71,14.71,0,0,0-4.19-3.81A7,7,0,0,0,128.18,24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.37,38.93,28.87,25.36A3.63,3.63,0,0,0,25.41,25l-.92.56-6.76,4.17a.07.07,0,0,0,0,.1c.34.71,3.53,7.39,3.82,8.62.12.52,1.12,5.62,2.28,11.55v3a10.46,10.46,0,0,0,1.58,5.15s0,0,0,0c1.2,6.2,2.22,11.49,2.25,11.63h0L31.11,78a.1.1,0,0,0,.12,0l8-4.64a.08.08,0,0,0,0-.1l-.59-1.68h0a20.53,20.53,0,0,1-.32-2.6L48.45,80.27a.08.08,0,0,0,.11,0L56,75.71l.12-.07h0a3.61,3.61,0,0,0,1.41-3.23V47.8A11.36,11.36,0,0,0,52.37,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.51,80.89a.66.66,0,0,1-.5-.22l-8.92-9.92c0,.23.07.46.12.69l.58,1.64a.68.68,0,0,1-.3.81L31.3,78.66,31,78.58a.7.7,0,0,1-.41-.38L27,69.82l-2.23-11.5A10.92,10.92,0,0,1,23.2,53V50c-.54-2.74-2.12-10.85-2.26-11.49-.21-.87-2.17-5.12-3.78-8.5a.67.67,0,0,1,.26-.86l7.68-4.73a4.22,4.22,0,0,1,4.07.41L52.66,38.42a12,12,0,0,1,5.42,9.38V72.41a4.17,4.17,0,0,1-1.69,3.73l-.14.09-7.38,4.56A.65.65,0,0,1,48.51,80.89ZM37.63,67.35l11,12.21,7-4.35.4.45-.32-.5a3.05,3.05,0,0,0,1.17-2.75V47.8a10.84,10.84,0,0,0-4.83-8.36L28.57,25.88a3.07,3.07,0,0,0-2.9-.4l-7.25,4.46c1,2.12,3.4,7.2,3.67,8.32.1.45.83,4.13,2.28,11.58V53a10,10,0,0,0,1.5,4.85l.05.09L26,58,28.2,69.58l3.23,7.63,7.1-4.13-.48-1.4A20.55,20.55,0,0,1,37.72,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.34,38.93l-22-12.67-11.07,7L42.82,45.62l5,.79,7.62-4.53A9.84,9.84,0,0,0,52.34,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.9,47l-5.35-.87L18.06,33.26l12.25-7.69L52.64,38.42a10.51,10.51,0,0,1,3.25,3.12l.36.52Zm-4.89-2,4.65.74,6.88-4.09a8.85,8.85,0,0,0-2.49-2.26L30.34,27l-9.91,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.69,50.45s-9.52,2.25-10.13,2.48a122.37,122.37,0,0,0-13,11.22c.63,3.25,1.06,5.51,1.08,5.6h0L31.11,78a.1.1,0,0,0,.12,0l8-4.64a.08.08,0,0,0,0-.1l-.59-1.68h0a20.53,20.53,0,0,1-.32-2.6L48.45,80.27a.08.08,0,0,0,.11,0L56,75.71l.12-.07h0a3.61,3.61,0,0,0,1.41-3.23V47.8a8.65,8.65,0,0,0-.22-1.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.63,
    y: 51.19,
    width: 6.58,
    height: 0.79,
    transform: "translate(-18.92 35.36) rotate(-31.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.44,
    y: 73.25,
    width: 6.58,
    height: 0.79,
    transform: "translate(-30.36 38.44) rotate(-31.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.86,43.62,21.32,30c-2.81-1.62-5.08-.31-5.08,2.93V57.61a11.22,11.22,0,0,0,5.08,8.8L24,68a2.26,2.26,0,0,1,1,1.51A13.34,13.34,0,0,0,30.15,78c.75.55,1.34.08,1.12-.88A19.6,19.6,0,0,1,30.73,73c0-.64.46-.9,1-.58L44.86,80c2.8,1.62,5.08.31,5.08-2.93V52.42A11.25,11.25,0,0,0,44.86,43.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.13,81.29a5.28,5.28,0,0,1-2.57-.77L31.45,73a.45.45,0,0,0-.13-.06.45.45,0,0,1,0,.12,19.26,19.26,0,0,0,.53,4,1.49,1.49,0,0,1-.49,1.66,1.34,1.34,0,0,1-1.56-.18,13.82,13.82,0,0,1-5.39-8.93,1.7,1.7,0,0,0-.71-1.1L21,66.93a11.93,11.93,0,0,1-5.38-9.32V33a4.12,4.12,0,0,1,1.79-3.8,4.11,4.11,0,0,1,4.18.36L45.15,43.11a11.89,11.89,0,0,1,5.38,9.31V77.07a4.11,4.11,0,0,1-1.78,3.8A3.23,3.23,0,0,1,47.13,81.29ZM31.29,71.7a1.57,1.57,0,0,1,.75.22l13.11,7.57a3,3,0,0,0,3,.36,3,3,0,0,0,1.2-2.78V52.42a10.59,10.59,0,0,0-4.79-8.29L21,30.54a3,3,0,0,0-3-.36A3,3,0,0,0,16.83,33V57.61a10.6,10.6,0,0,0,4.78,8.29l2.68,1.55a2.82,2.82,0,0,1,1.29,1.93,12.6,12.6,0,0,0,4.93,8.17.45.45,0,0,0,.24.12s0-.14-.06-.38A20.46,20.46,0,0,1,30.13,73a1.31,1.31,0,0,1,.59-1.17A1.13,1.13,0,0,1,31.29,71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.27,65,41.4,62.64a9,9,0,0,0,.3-2.36,13.47,13.47,0,0,0-.3-2.71l1.87-.17c.27,0,.36-.37.21-.77l-1.69-4.36c-.16-.4-.5-.7-.77-.68l-1.87.17A19.36,19.36,0,0,0,35.34,47V44.53a1.23,1.23,0,0,0-.56-1l-3.38-2c-.32-.18-.57,0-.57.33v2.49a5,5,0,0,0-3.81.33l-1.86-2.31c-.27-.34-.62-.43-.77-.21L22.7,44.64a.93.93,0,0,0,.2,1L24.77,48a9.49,9.49,0,0,0-.29,2.37,14.18,14.18,0,0,0,.29,2.7l-1.87.17c-.27,0-.36.37-.2.77l1.69,4.36c.15.4.5.71.77.68L27,58.85a19.36,19.36,0,0,0,3.81,4.74v2.49a1.2,1.2,0,0,0,.57,1l3.38,2c.31.18.56,0,.56-.33V66.19a5,5,0,0,0,3.81-.33L41,68.18c.27.33.61.42.77.2L43.48,66A1,1,0,0,0,43.27,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,69.48a.89.89,0,0,1-.45-.13L31.2,67.4a1.62,1.62,0,0,1-.76-1.32V63.76a19.41,19.41,0,0,1-3.63-4.49l-1.62.14c-.5.05-1-.43-1.17-.93l-1.69-4.36a1.13,1.13,0,0,1,0-1,.66.66,0,0,1,.52-.31l1.43-.13a14.38,14.38,0,0,1-.22-2.35,10,10,0,0,1,.26-2.28L22.6,45.89a1.32,1.32,0,0,1-.23-1.48L24.07,42a.65.65,0,0,1,.53-.29,1.13,1.13,0,0,1,.87.48l1.66,2.06a5.29,5.29,0,0,1,3.31-.32v-2a.73.73,0,0,1,1.15-.67l3.39,2a1.66,1.66,0,0,1,.76,1.32v2.32a20.17,20.17,0,0,1,3.63,4.49L41,51.2a1.3,1.3,0,0,1,1.17.93l1.7,4.36a1.13,1.13,0,0,1,0,1,.68.68,0,0,1-.51.32l-1.44.12a13.46,13.46,0,0,1,.22,2.36,9.87,9.87,0,0,1-.26,2.27l1.75,2.17a1.31,1.31,0,0,1,.22,1.48l-1.69,2.41a.69.69,0,0,1-.54.29,1.14,1.14,0,0,1-.86-.48l-1.66-2.06a5.37,5.37,0,0,1-3.31.33v2a.77.77,0,0,1-.37.71A.67.67,0,0,1,35,69.48Zm-7.79-11,.12.22a19,19,0,0,0,3.73,4.63l.14.12v2.67a.84.84,0,0,0,.36.63l3.35,1.94v-3l.49.13A4.68,4.68,0,0,0,39,65.52l.29-.17,2.07,2.58a.71.71,0,0,0,.19.16l1.64-2.34a.71.71,0,0,0-.19-.54l-2-2.48.05-.19a8.75,8.75,0,0,0,.28-2.26A14.12,14.12,0,0,0,41,57.65l-.09-.43,2.23-.2a.72.72,0,0,0,0-.24l-1.69-4.36A.73.73,0,0,0,41,52l-2.1.19L38.81,52a19.1,19.1,0,0,0-3.73-4.64L35,47.2V44.53a.87.87,0,0,0-.37-.63L31.23,42v3l-.5-.13a4.61,4.61,0,0,0-3.51.3l-.3.16-2.07-2.58a.58.58,0,0,0-.18-.16L23,44.86a.75.75,0,0,0,.19.54l2,2.48-.06.19a9.23,9.23,0,0,0-.28,2.27A13.36,13.36,0,0,0,25.16,53l.09.44L23,53.59a.59.59,0,0,0,.05.25l1.69,4.36a.73.73,0,0,0,.37.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.17,57.66c0,2.6-1.83,3.66-4.08,2.36A9,9,0,0,1,29,53c0-2.6,1.82-3.65,4.08-2.35A9,9,0,0,1,37.17,57.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.91,61a4.14,4.14,0,0,1-2-.61A9.47,9.47,0,0,1,28.61,53,3.24,3.24,0,0,1,30,50a3.22,3.22,0,0,1,3.27.28,9.49,9.49,0,0,1,4.28,7.41,3.22,3.22,0,0,1-1.39,3A2.47,2.47,0,0,1,34.91,61ZM31.27,50.43a1.81,1.81,0,0,0-.87.22,2.51,2.51,0,0,0-1,2.3,8.58,8.58,0,0,0,3.88,6.72,2.5,2.5,0,0,0,2.49.29,2.49,2.49,0,0,0,1-2.3,8.58,8.58,0,0,0-3.88-6.72A3.27,3.27,0,0,0,31.27,50.43Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 147.94,
    cy: 106.03,
    rx: 26.12,
    ry: 45.24,
    transform: "translate(-33.19 88.18) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.75,141a24.77,24.77,0,0,1-12.2-3.73c-14.79-8.54-26.83-29.38-26.83-46.46,0-8.45,2.89-14.77,8.14-17.8S141,70.6,148.34,74.82c14.79,8.54,26.82,29.39,26.82,46.47,0,8.44-2.88,14.76-8.13,17.79A14.41,14.41,0,0,1,159.75,141ZM136.14,72.68a12.8,12.8,0,0,0-6.49,1.66c-4.74,2.73-7.35,8.57-7.35,16.43,0,16.57,11.68,36.8,26,45.09,6.8,3.93,13.16,4.59,17.9,1.85s7.35-8.57,7.35-16.42c0-16.58-11.68-36.81-26-45.1A23.29,23.29,0,0,0,136.14,72.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.37,127.73a5.87,5.87,0,0,1-2.84-.94,10.29,10.29,0,0,1-3.64-3.47,8.73,8.73,0,0,1-1.33-4.63c0-1.83.54-3,1.61-3.57s2.4-.29,4.15.72a10,10,0,0,1,3.63,3.48,8.88,8.88,0,0,1,1.25,4.6c0,1.82-.55,3-1.63,3.54A2.65,2.65,0,0,1,150.37,127.73Zm-5-11.3a1.14,1.14,0,0,0-.48.1c-.61.31-.74,1.34-.74,2.16a7.11,7.11,0,0,0,1.1,3.8,8.51,8.51,0,0,0,3.08,2.93c1.15.67,2,.88,2.56.62s.74-1.32.74-2.12a7.37,7.37,0,0,0-1-3.8,8.34,8.34,0,0,0-3.06-2.91A4.88,4.88,0,0,0,145.36,116.43Zm6.88-.45-8.64-5-1.19-26.17,11,6.37Zm-7.1-5.92,5.65,3.26,1-21.25-7.69-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.87,117l-23.49-13.56a3.66,3.66,0,0,0-3.47-.42l-.92.56-6.76,4.17a.09.09,0,0,0,0,.1c.35.72,3.54,7.39,3.83,8.62.12.52,1.12,5.62,2.27,11.56v3a10.43,10.43,0,0,0,1.58,5.15,0,0,0,0,1,0,0c1.2,6.19,2.23,11.48,2.25,11.62h0l3.48,8.22a.08.08,0,0,0,.12,0l8-4.64a.08.08,0,0,0,0-.1l-.59-1.68h0a18.87,18.87,0,0,1-.33-2.59L254,158.38a.09.09,0,0,0,.11,0l7.41-4.58.11-.07h0a3.61,3.61,0,0,0,1.42-3.24v-24.6A11.37,11.37,0,0,0,257.87,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254,159a.68.68,0,0,1-.51-.23l-8.92-9.92.12.7.58,1.64a.68.68,0,0,1-.3.81l-8.19,4.77-.32-.08a.7.7,0,0,1-.41-.38L232.56,148l-2.24-11.56a10.87,10.87,0,0,1-1.62-5.38v-2.94c-1.36-7-2.16-11-2.26-11.47-.23-1-2.57-6-3.78-8.5a.66.66,0,0,1,.26-.86l7.68-4.73a4.21,4.21,0,0,1,4.07.41l23.5,13.56a12,12,0,0,1,5.42,9.39v24.6a4.2,4.2,0,0,1-1.69,3.74l-.14.09-7.39,4.56A.64.64,0,0,1,254,159Zm-10.89-13.55,11,12.22,7.13-4.41a3.06,3.06,0,0,0,1.16-2.75v-24.6a10.86,10.86,0,0,0-4.82-8.36L234.08,104a3.11,3.11,0,0,0-2.9-.4l-7.25,4.47c.88,1.84,3.39,7.15,3.66,8.32.14.58,1.32,6.61,2.28,11.58l0,.13v3a9.9,9.9,0,0,0,1.49,4.85l.07.18,2.25,11.6,3.24,7.64,7.1-4.14-.49-1.39a22.46,22.46,0,0,1-.33-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.85,117l-22-12.66-11.08,6.95,23.58,12.41,4.95.78L260.9,120A10,10,0,0,0,257.85,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.4,125.13l-5.35-.88-24.48-12.89,12.24-7.68,22.33,12.84a10.51,10.51,0,0,1,3.25,3.12l.36.53Zm-4.88-2,4.64.73,6.88-4.08a8.7,8.7,0,0,0-2.49-2.26l-21.71-12.49-9.9,6.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.19,128.56s-9.52,2.24-10.13,2.47a122.75,122.75,0,0,0-13,11.23c.63,3.25,1.06,5.5,1.08,5.59h0l3.48,8.22a.08.08,0,0,0,.12,0l8-4.64a.08.08,0,0,0,0-.1l-.59-1.68h0a18.87,18.87,0,0,1-.33-2.59L254,158.38a.09.09,0,0,0,.11,0l7.41-4.58.11-.07h0a3.61,3.61,0,0,0,1.42-3.24v-24.6a8.09,8.09,0,0,0-.23-1.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 256.13,
    y: 129.3,
    width: 6.58,
    height: 0.79,
    transform: "translate(-29.67 153.04) rotate(-31.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 255.95,
    y: 151.36,
    width: 6.58,
    height: 0.79,
    transform: "translate(-41.12 156.13) rotate(-31.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.36,121.72l-23.54-13.59c-2.8-1.62-5.08-.3-5.08,2.94v24.65a11.25,11.25,0,0,0,5.08,8.8l2.68,1.55a2.25,2.25,0,0,1,1,1.51,13.3,13.3,0,0,0,5.16,8.55c.74.55,1.33.08,1.12-.87a19.66,19.66,0,0,1-.55-4.14c0-.65.46-.9,1-.58l13.11,7.57c2.81,1.62,5.08.31,5.08-2.93V130.52A11.22,11.22,0,0,0,250.36,121.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.63,159.4a5.2,5.2,0,0,1-2.57-.78L237,151.05a.31.31,0,0,0-.13-.05s0,.06,0,.12a19.34,19.34,0,0,0,.53,4,1.48,1.48,0,0,1-.48,1.65,1.33,1.33,0,0,1-1.56-.17,13.84,13.84,0,0,1-5.4-8.94,1.73,1.73,0,0,0-.7-1.09L226.53,145a11.89,11.89,0,0,1-5.38-9.31V111.07a3.67,3.67,0,0,1,6-3.45l23.54,13.59a11.9,11.9,0,0,1,5.37,9.31v24.66a4.14,4.14,0,0,1-1.78,3.8A3.21,3.21,0,0,1,252.63,159.4Zm-15.84-9.59a1.5,1.5,0,0,1,.76.22l13.11,7.57a2.52,2.52,0,0,0,4.19-2.42V130.52a10.58,10.58,0,0,0-4.79-8.28l-23.53-13.59a2.53,2.53,0,0,0-4.2,2.42v24.65a10.62,10.62,0,0,0,4.79,8.29l2.68,1.54a2.86,2.86,0,0,1,1.28,1.93,12.66,12.66,0,0,0,4.93,8.18.75.75,0,0,0,.24.12s0-.14-.05-.39a19.74,19.74,0,0,1-.56-4.27,1.28,1.28,0,0,1,.59-1.16A1.09,1.09,0,0,1,236.79,149.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 238.59,
    cy: 133.12,
    rx: 8.78,
    ry: 15.2,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -34.59, 137.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.39,147.4a10.12,10.12,0,0,1-5-1.53c-6-3.48-10.94-12-10.94-19,0-3.46,1.19-6.06,3.34-7.3s5-1,8,.75c6,3.49,11,12,11,19,0,3.47-1.19,6.06-3.35,7.31A6,6,0,0,1,243.39,147.4Zm-9.6-27.77a5.18,5.18,0,0,0-2.6.66c-1.91,1.1-2.95,3.45-2.95,6.62,0,6.72,4.73,14.92,10.55,18.28,2.74,1.58,5.3,1.85,7.21.75s2.95-3.45,2.95-6.62c0-6.71-4.74-14.92-10.56-18.27A9.3,9.3,0,0,0,233.79,119.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M235.38,132.65l-.2-.12a3.18,3.18,0,0,1-1.32-2.54v-3.68c0-1,.59-1.43,1.32-1l.2.11a3.18,3.18,0,0,1,1.33,2.54v3.68C236.71,132.62,236.12,133.07,235.38,132.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.91,133.2a1.45,1.45,0,0,1-.72-.21l-.2-.12a3.55,3.55,0,0,1-1.53-2.88v-3.68a1.54,1.54,0,0,1,.66-1.41,1.2,1.2,0,0,1,1.26.07l.2.11a3.55,3.55,0,0,1,1.53,2.88v3.68a1.56,1.56,0,0,1-.66,1.42A1.14,1.14,0,0,1,235.91,133.2Zm-.33-.9a.5.5,0,0,0,.48.07.85.85,0,0,0,.26-.73V128a2.81,2.81,0,0,0-1.13-2.2l-.2-.11a.51.51,0,0,0-.48-.07.85.85,0,0,0-.26.73V130a2.8,2.8,0,0,0,1.13,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242,136.47l-.2-.12a3.19,3.19,0,0,1-1.33-2.54v-3.68c0-1,.6-1.43,1.33-1l.2.11a3.2,3.2,0,0,1,1.33,2.54v3.68C243.33,136.44,242.73,136.89,242,136.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.53,137a1.48,1.48,0,0,1-.73-.21l-.2-.12a3.57,3.57,0,0,1-1.52-2.88v-3.68a1.59,1.59,0,0,1,.65-1.42,1.27,1.27,0,0,1,1.27.07l.2.12a3.57,3.57,0,0,1,1.52,2.88v3.68a1.57,1.57,0,0,1-.65,1.42A1.14,1.14,0,0,1,242.53,137Zm-1.26-7.66a.23.23,0,0,0-.14,0,.85.85,0,0,0-.26.73v3.68A2.79,2.79,0,0,0,242,136l.2.11a.49.49,0,0,0,.47.07.85.85,0,0,0,.26-.73v-3.68a2.79,2.79,0,0,0-1.13-2.2l-.2-.11A.65.65,0,0,0,241.27,129.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243,142.52a9.63,9.63,0,0,0-3.25-3.36L237,137.6a3.21,3.21,0,0,0-3-.4l-.35-.7a3.93,3.93,0,0,1,3.76.42l2.7,1.56a10.38,10.38,0,0,1,3.53,3.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.62,
    y: 91.61,
    width: 0.79,
    height: 5.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 25.25,
    y: 93.85,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 64.94,
    y: 99.19,
    width: 0.79,
    height: 5.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.34,
    y: 129.35,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.16,
    y: 47.91,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 161.95,
    y: 37.24,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 110.92,
    y: 51.97,
    width: 0.79,
    height: 5.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 108.56,
    y: 54.21,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 260.3,
    y: 167.26,
    width: 0.79,
    height: 5.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.93,
    y: 169.5,
    width: 5.53,
    height: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.81,189.13l-3.92-2.4a.59.59,0,0,0-.61,0h0l0,0-4,2.36a.21.21,0,0,0-.07.27l3.75,6.57a.17.17,0,0,1,0,.1v7a2.16,2.16,0,0,0,.9,1.73l-3.53-1.91a.27.27,0,0,1,.07.08l3.73,6.53a.21.21,0,0,0,.28.08l4-2.36a.84.84,0,0,0,.28-.71V190.85A2.16,2.16,0,0,0,249.81,189.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.34,210.1l-.19,0a.72.72,0,0,1-.43-.33L242,203.2a.32.32,0,0,0,.11.12l.5-.9,1.91,1a2.71,2.71,0,0,1,0-.4v-7l-3.7-6.49a.71.71,0,0,1,.25-1l4-2.36a1.06,1.06,0,0,1,1.16,0l3.92,2.4a2.64,2.64,0,0,1,1.16,2.16v15.64a1.29,1.29,0,0,1-.51,1.13l-4,2.38A.65.65,0,0,1,246.34,210.1Zm-2.6-5.9,2.71,4.75,3.72-2.19a.86.86,0,0,0,0-.27V190.85a1.67,1.67,0,0,0-.65-1.28h0l-3.92-2.4-.08,0h0l-3.73,2.22,3.6,6.3a.74.74,0,0,1,.09.36v7a1.65,1.65,0,0,0,.65,1.28l-.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.2,201.5s1.45-8.51,2.88-1.27l-2.74,2.63.1.1,3.69,6.47a.28.28,0,0,0,.37.1l3.93-2.33a.84.84,0,0,0,.28-.71V191a.06.06,0,0,0-.09-.05l-4.11,2.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.36,210.08l-.2,0a.79.79,0,0,1-.47-.37l-3.78-6.52-.75,1.42.54-3.16c.52-3,1.23-4.61,2.12-4.62a.68.68,0,0,1,.26,0l2.06-3.91.16-.05,4.32-2.57.32.15a.59.59,0,0,1,.29.5v15.53a1.29,1.29,0,0,1-.51,1.13l-4,2.35A.83.83,0,0,1,246.36,210.08ZM243,202.93l3.44,6,3.72-2.19a.86.86,0,0,0,0-.27V191.76l-3.31,2-2,3.89a10.39,10.39,0,0,1,.74,2.52l.06.27Zm1.2-4.13L242.54,202l2-1.9C244.41,199.52,244.3,199.11,244.21,198.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M245.6,209.67l-3.92-2.39a2.16,2.16,0,0,1-.9-1.73V189.91c0-.66.4-1,.9-.68l3.92,2.4a2.16,2.16,0,0,1,.9,1.72V209C246.5,209.66,246.1,210,245.6,209.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246,210.29a1.35,1.35,0,0,1-.62-.17h0l-3.92-2.39a2.65,2.65,0,0,1-1.14-2.17V189.91a1.29,1.29,0,0,1,.56-1.17,1.08,1.08,0,0,1,1.11,0l3.93,2.4a2.66,2.66,0,0,1,1.15,2.16V209a1.3,1.3,0,0,1-.57,1.18A1,1,0,0,1,246,210.29Zm-.1-1.06.1,0h0s0-.09,0-.28V193.35a1.67,1.67,0,0,0-.65-1.28l-3.93-2.4a.15.15,0,0,0-.09,0h0s0,.09,0,.27v15.64a1.65,1.65,0,0,0,.65,1.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 244.25,
    y: 189.07,
    width: 4.76,
    height: 1.03,
    transform: "translate(-62.95 159.09) rotate(-31.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.58,
    y: 202.98,
    width: 4.16,
    height: 0.79,
    transform: "translate(-69.25 157.22) rotate(-31.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.5,73.57l-3.92-2.4a.55.55,0,0,0-.61,0h0l0,0-4,2.35a.21.21,0,0,0-.08.28l3.75,6.56a.19.19,0,0,1,0,.1v7a2.18,2.18,0,0,0,.9,1.73l-3.53-1.91a.16.16,0,0,1,.07.07l3.74,6.54a.19.19,0,0,0,.27.07l4-2.35a.82.82,0,0,0,.28-.71V75.29A2.14,2.14,0,0,0,92.5,73.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89,94.54a.57.57,0,0,1-.18,0,.72.72,0,0,1-.44-.34l-3.73-6.53a.29.29,0,0,0,.11.11l.5-.89,1.91,1a2.8,2.8,0,0,1,0-.4V80.54L83.46,74a.72.72,0,0,1,.25-1l4-2.35a1.06,1.06,0,0,1,1.16,0l3.92,2.39a2.67,2.67,0,0,1,1.16,2.17V90.93a1.32,1.32,0,0,1-.51,1.13l-4,2.38A.82.82,0,0,1,89,94.54Zm-2.6-5.9,2.72,4.75,3.71-2.19h0a1.87,1.87,0,0,0,0-.27V75.29A1.67,1.67,0,0,0,92.24,74h0l-3.92-2.39a.13.13,0,0,0-.08,0h0L84.5,73.8l3.6,6.3a.73.73,0,0,1,.09.35v7a1.65,1.65,0,0,0,.65,1.28l-.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.9,85.94s1.44-8.51,2.87-1.27L85,87.3l.09.1,3.7,6.47a.26.26,0,0,0,.36.09l3.93-2.32a.82.82,0,0,0,.28-.71V75.4a.06.06,0,0,0-.09-.05L89.2,77.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.05,94.51l-.2,0a.79.79,0,0,1-.47-.37L84.6,87.59,83.85,89l.54-3.17c.52-3,1.23-4.6,2.13-4.61l.26,0,2.14-3.91,4.39-2.61.32.15a.57.57,0,0,1,.29.5V90.93a1.32,1.32,0,0,1-.51,1.13l-4,2.34A.71.71,0,0,1,89.05,94.51Zm-3.34-7.14,3.43,6,3.72-2.19h0a1.87,1.87,0,0,0,0-.27V76.19l-3.31,2-2,3.88a10.19,10.19,0,0,1,.74,2.53l.06.27Zm1.19-4.13L85.23,86.4l2-1.91C87.1,84,87,83.55,86.9,83.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.29,94.11l-3.92-2.4a2.14,2.14,0,0,1-.9-1.72V74.35c0-.66.4-1,.9-.68l3.92,2.39a2.18,2.18,0,0,1,.91,1.73V93.43C89.2,94.09,88.79,94.4,88.29,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.65,94.73a1.19,1.19,0,0,1-.61-.18h0l-3.91-2.4A2.64,2.64,0,0,1,83,90V74.35a1.27,1.27,0,0,1,.57-1.17,1.09,1.09,0,0,1,1.1,0l3.93,2.41a2.63,2.63,0,0,1,1.15,2.16V93.43a1.29,1.29,0,0,1-.57,1.17A1,1,0,0,1,88.65,94.73Zm-.1-1.06.1,0a2.57,2.57,0,0,0,0-.28V77.79A1.67,1.67,0,0,0,88,76.51l-3.93-2.4-.09,0h0a1.33,1.33,0,0,0,0,.28V90a1.67,1.67,0,0,0,.65,1.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.94,
    y: 73.51,
    width: 4.76,
    height: 1.03,
    transform: "translate(-25.63 58.43) rotate(-31.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 89.27,
    y: 87.42,
    width: 4.16,
    height: 0.79,
    transform: "translate(-32.2 59.69) rotate(-31.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.7,57l-3.91-2.4a.56.56,0,0,0-.62,0h0l0,0-4,2.35a.2.2,0,0,0-.07.28l3.75,6.56a.36.36,0,0,1,0,.1v.72a2.17,2.17,0,0,0,.91,1.73L85.25,64.4a.3.3,0,0,1,.08.08L89.06,71a.21.21,0,0,0,.28.08l4-2.36a.84.84,0,0,0,.28-.71V58.7A2.15,2.15,0,0,0,92.7,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.24,71.63a.58.58,0,0,1-.19,0,.77.77,0,0,1-.44-.33l-3.73-6.54a.34.34,0,0,0,.12.12l.5-.9,1.9,1a2.69,2.69,0,0,1,0-.4v-.64l-3.71-6.49a.72.72,0,0,1,.26-1l4-2.35a1.06,1.06,0,0,1,1.16,0L93,56.53a2.67,2.67,0,0,1,1.15,2.17V68a1.32,1.32,0,0,1-.5,1.13l-4,2.38A.78.78,0,0,1,89.24,71.63Zm-2.61-5.9,2.72,4.75,3.71-2.19a.86.86,0,0,0,0-.27V58.7a1.69,1.69,0,0,0-.64-1.28h0L88.52,55a.15.15,0,0,0-.09,0h0L84.7,57.21l3.6,6.3a.74.74,0,0,1,.1.35v.72A1.67,1.67,0,0,0,89,65.86l-.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.1,63s1.45-8.51,2.87-1.27l-2.73,2.63.1.1L89,71a.25.25,0,0,0,.36.09l3.94-2.32a.84.84,0,0,0,.28-.71V58.81a.06.06,0,0,0-.09-.05L89.4,61.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.26,71.6a.65.65,0,0,1-.2,0,.84.84,0,0,1-.48-.37l-3.67-6.42-.37-.37.34-.4.64-.61-1.08.46.15-.92c.52-3.06,1.24-4.61,2.13-4.62h0c.71,0,1.19.81,1.63,2.76l.83-.36,4.32-2.57.32.15a.57.57,0,0,1,.29.5V68a1.32,1.32,0,0,1-.5,1.13l-4,2.35A.76.76,0,0,1,89.26,71.6Zm-3.35-7.14,3.44,6,3.71-2.19a.86.86,0,0,0,0-.27V59.6l-3.43,2-1.48.63Zm.81-5a9.16,9.16,0,0,0-.93,2.76l1.61-.68A6.4,6.4,0,0,0,86.72,59.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.5,71.2l-3.92-2.39a2.17,2.17,0,0,1-.91-1.73V57.76c0-.66.41-1,.91-.68l3.92,2.39a2.19,2.19,0,0,1,.9,1.73v9.32C89.4,71.18,89,71.49,88.5,71.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.86,71.82a1.29,1.29,0,0,1-.62-.17h0l-3.92-2.4a2.63,2.63,0,0,1-1.15-2.16V57.76a1.29,1.29,0,0,1,.57-1.17,1.09,1.09,0,0,1,1.1,0L88.76,59a2.63,2.63,0,0,1,1.15,2.16v9.32a1.26,1.26,0,0,1-.57,1.17A.91.91,0,0,1,88.86,71.82Zm-.1-1.06.09,0h0a1.33,1.33,0,0,0,0-.28V61.2a1.68,1.68,0,0,0-.65-1.28l-3.93-2.4-.09,0h0a2.21,2.21,0,0,0,0,.28v9.32a1.67,1.67,0,0,0,.64,1.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.15,
    y: 56.92,
    width: 4.76,
    height: 1.03,
    transform: "translate(-16.83 56.04) rotate(-31.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 89.47,
    y: 64.51,
    width: 4.16,
    height: 0.79,
    transform: "translate(-20.36 56.52) rotate(-31.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.47,162.17l-3.92-2.4a.56.56,0,0,0-.61,0h0l-4,2.36a.2.2,0,0,0-.08.27L37.62,169a.17.17,0,0,1,0,.1v.72a2.14,2.14,0,0,0,.9,1.72L35,169.6a.12.12,0,0,1,.07.07l3.74,6.54a.19.19,0,0,0,.27.07l4-2.36a.82.82,0,0,0,.28-.7V163.9A2.16,2.16,0,0,0,42.47,162.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39,176.82a.55.55,0,0,1-.18,0,.72.72,0,0,1-.44-.34l-3.73-6.53.11.11.5-.89,1.91,1a2.56,2.56,0,0,1,0-.39v-.64l-3.71-6.49a.72.72,0,0,1,.25-1l4-2.36a1.08,1.08,0,0,1,1.16,0l3.92,2.4a2.65,2.65,0,0,1,1.16,2.17v9.32a1.32,1.32,0,0,1-.51,1.13l-4,2.37A.65.65,0,0,1,39,176.82Zm-2.6-5.9,2.71,4.76,3.72-2.2s0-.08,0-.26V163.9a1.65,1.65,0,0,0-.65-1.28h0l-3.92-2.4-.08,0-3.73,2.22,3.6,6.3a.77.77,0,0,1,.09.36v.72a1.67,1.67,0,0,0,.65,1.28l-.5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.86,168.23s1.45-8.51,2.88-1.28L35,169.59l.1.1,3.7,6.46a.26.26,0,0,0,.36.1l3.93-2.33a.82.82,0,0,0,.28-.7V164a.06.06,0,0,0-.09-.05l-4.11,2.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39,176.8l-.2,0a.74.74,0,0,1-.47-.36L34.69,170l-.32-.32.28-.46.64-.62-1.09.47.16-.93c.52-3,1.23-4.6,2.12-4.61h0c.7,0,1.19.8,1.62,2.75l.82-.35,4.34-2.57.32.14a.59.59,0,0,1,.29.5v9.22a1.32,1.32,0,0,1-.51,1.13l-4,2.34A.8.8,0,0,1,39,176.8Zm-3.34-7.14,3.43,6,3.72-2.2s0-.08,0-.26V164.8l-3.5,2.07-1.42.61Zm.81-5a9,9,0,0,0-.94,2.76l1.61-.69A6.42,6.42,0,0,0,36.49,164.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.26,176.4,34.34,174a2.16,2.16,0,0,1-.9-1.72V163c0-.67.4-1,.9-.69l3.92,2.4a2.16,2.16,0,0,1,.9,1.73v9.31C39.16,176.38,38.76,176.69,38.26,176.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.62,177a1.25,1.25,0,0,1-.62-.18h0l-3.91-2.4a2.66,2.66,0,0,1-1.15-2.16V163a1.28,1.28,0,0,1,.57-1.18,1.09,1.09,0,0,1,1.1.05l3.93,2.4a2.66,2.66,0,0,1,1.15,2.17v9.31a1.3,1.3,0,0,1-.57,1.18A1,1,0,0,1,38.62,177Zm-.1-1.06c.06,0,.1,0,.1,0a1.91,1.91,0,0,0,0-.28V166.4a1.69,1.69,0,0,0-.65-1.29l-3.92-2.4a.21.21,0,0,0-.1,0s0,.09,0,.28v9.32a1.67,1.67,0,0,0,.65,1.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.91,
    y: 162.12,
    width: 4.76,
    height: 1.03,
    transform: "translate(-80.06 45.38) rotate(-31.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.24,
    y: 169.71,
    width: 4.16,
    height: 0.79,
    transform: "translate(-81.75 45.62) rotate(-31.02)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryNotFound);
export default __webpack_public_path__ + "static/media/delivery-not-found.977b77fd0b8451fb275b55a1b1017b61.svg";
export { ForwardRef as ReactComponent };